/* tslint:disable:max-line-length */
/* tslint:disable:variable-name */
export const API_URL = {
  ADMIN: {
    addConfigEntryByID: () => `api/admin/system-config`,
    closeUserSession: (id: number | string) => `api/admin/usersession/${id}/close`,
    deleteLockedLogin: (lockType: number | string, lockId: number | string) => `api/admin/locks/${lockType}/${lockId}`,
    deleteSystemrole: () => `api/admin/systemroles`,
    getAdminLogTypes: () => `api/admin/log-types`,
    getCustomerInfo: () => `api/admin/customer-info`,
    getEmailSignature: () => `api/admin/signature`,
    getFilteredAdminLogs: () => `api/admin/logs`,
    getLockedLogins: () => `api/admin/locks`,
    getSystemCheckInfo: () => `api/admin/system-check`,
    getSystemConfig: () => `api/admin/system-config`,
    getSystemInfo: () => `api/admin/system-info`,
    getSystemroles: () => `api/admin/systemroles`,
    getUserLiveTicker: () => `api/admin/userliveticker`,
    reloadSystemConfigurationOnAllNodes: () => `api/admin/system-config/reload`,
    removeConfigEntryByID: (entryID: number | string) => `api/admin/system-config/${entryID}`,
    setMailServiceCommand: () => `api/admin/mail-service`,
    updateConfigEntryByID: (entryID: number | string) => `api/admin/system-config/${entryID}`,
    updateCustomerInfo: () => `api/admin/customer-info`,
    updateEmailSignature: () => `api/admin/signature`,
    updateEnvironmentThemeData: () => `api/admin/theme`,
    updateReleaseNotes: () => `api/admin/release-notes`,
    updateSystemrole: () => `api/admin/systemroles`,
  },
  ADMIN_MIGRATION: {
    getNumberOfMeetingsToMigrate: () => `api/admin/migration/meetings`,
    patchMeetingProtocols: () => `api/admin/migration/meetings/migrate`,
  },
  ADMIN_OAUTH2: {
    createServer: () => `api/admin/oauth2/servers`,
    deleteServer: (serverId: number | string) => `api/admin/oauth2/servers/${serverId}`,
    getServer: (serverId: number | string) => `api/admin/oauth2/servers/${serverId}`,
    updateServer: (serverId: number | string) => `api/admin/oauth2/servers/${serverId}`,
  },
  ADMIN_PRINTJOBPROVIDER: {
    createProvider: () => `api/admin/printjobprovider`,
    deleteProvider: (id: number | string) => `api/admin/printjobprovider/${id}`,
    getAllProviders: () => `api/admin/printjobprovider`,
    getProviderDetails: (id: number | string) => `api/admin/printjobprovider/${id}`,
    removeUserAsProvider: (id: number | string, userId: number | string) =>
      `api/admin/printjobprovider/${id}/user/${userId}`,
    setUserAsProvider: (id: number | string, userId: number | string) =>
      `api/admin/printjobprovider/${id}/user/${userId}`,
    updateProviderBasics: (id: number | string) => `api/admin/printjobprovider/${id}/basics`,
  },
  ADMIN_PROJECTS: {
    changeFileOwnerInProject: () => `api/admin/projects/owner`,
    checkDirectory: () => `api/admin/projects/check-dir`,
    cloneProject: (projectId: number | string) => `api/admin/projects/${projectId}/clone`,
    convertProjectToTemplate: (projectId: number | string) => `api/admin/projects/${projectId}/template`,
    createProject: () => `api/admin/projects`,
    createProjectForPGAdmin: () => `api/admin/projects/pg-project`,
    createProjectMetadata: (projectId: number | string) => `api/admin/projects/${projectId}/metadata`,
    deleteProjectRightsRequests: () => `api/admin/projects/rights`,
    deleteProjectRightsRequestsById: (taskId: number | string) => `api/admin/projects/rights/${taskId}`,
    getActiveMetadataDefinitions: (projectId: number | string) =>
      `api/admin/projects/${projectId}/filename-conventions/active-definitions`,
    getAllFileOwnersInProject: (projectId: number | string) => `api/admin/projects/owner/${projectId}`,
    getAllProjects: () => `api/admin/projects`,
    getAllProviders_1: () => `api/admin/projects/providers`,
    getDirectoryMapping: (projectId: number | string) => `api/admin/projects/${projectId}/automapping-xml`,
    getDirectoryMappingText: (projectId: number | string) => `api/admin/projects/${projectId}/automapping-text`,
    getFileNameConventions: (projectId: number | string) => `api/admin/projects/${projectId}/filename-conventions`,
    getProject: (projectId: number | string) => `api/admin/projects/${projectId}`,
    getProjectMetadata: (projectId: number | string, metadataId: number | string) =>
      `api/admin/projects/${projectId}/metadata/${metadataId}`,
    getProjectMetadataList: (projectId: number | string) => `api/admin/projects/${projectId}/metadata`,
    getProjectPresets: () => `api/admin/projects/presets`,
    getProjectRightsRequests: () => `api/admin/projects/rights`,
    getProjectRightsRequestsById: (taskId: number | string) => `api/admin/projects/rights/${taskId}`,
    getProjectUsers: (prId: number | string) => `api/admin/projects/${prId}/users`,
    getStarterModules: () => `api/admin/projects/starter-modules`,
    releaseProjectRightsRequests: () => `api/admin/projects/rights`,
    releaseProjectRightsRequestsById: (taskId: number | string) => `api/admin/projects/rights/${taskId}`,
    saveDirectoryMapping: (projectId: number | string) => `api/admin/projects/${projectId}/automapping`,
    testFilename: (projectId: number | string) => `api/admin/projects/${projectId}/filename-conventions`,
    updateFileNameConventions: (projectId: number | string) => `api/admin/projects/${projectId}/filename-conventions`,
    updateProject: (projectId: number | string) => `api/admin/projects/${projectId}`,
    updateProjectGroupProject: (projectId: number | string) => `api/admin/projects/${projectId}/updatePG`,
    updateProjectMetadata: (projectId: number | string, metadataId: number | string) =>
      `api/admin/projects/${projectId}/metadata/${metadataId}`,
    updateProjectTimers: (projectId: number | string) => `api/admin/projects/${projectId}/timers`,
    updateProjectUsers: (prId: number | string) => `api/admin/projects/${prId}/users`,
  },
  ADMIN_REPORT: {
    getBillingReport: () => `api/admin/report/billing.excel`,
  },
  ADMIN_TEMPLATES: {
    convertTemplateToProject: (templateId: number | string) => `api/admin/templates/${templateId}/project`,
    createTemplate: () => `api/admin/templates`,
    getAllTemplates: () => `api/admin/templates`,
    getGroupsOfTemplateProject: (templateId: number | string) => `api/admin/templates/${templateId}/groups`,
    getTemplate: (templateId: number | string) => `api/admin/templates/${templateId}`,
    updateTemplate: (templateId: number | string) => `api/admin/templates/${templateId}`,
  },
  ADMIN_VALUETABLES: {
    createAttributes: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/attribute`,
    createTableReference: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/reference`,
    createValueTable: (projectId: number | string) => `api/projects/${projectId}/values/admin/table`,
    getAccessRightListOfTable: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/acl`,
    removeAccessRight: (projectId: number | string, tableId: number | string, aclId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/acl/${aclId}`,
    removeAttribute: (projectId: number | string, tableId: number | string, attributeId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/attribute/${attributeId}`,
    removeReference: (projectId: number | string, tableId: number | string, refId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/reference/${refId}`,
    setAccessRight: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/acl`,
    updateAttribute: (projectId: number | string, tableId: number | string, attributeId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/attribute/${attributeId}`,
    updateAttributePosition: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/attribute/position`,
    updateTableReference: (projectId: number | string, tableId: number | string, refId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}/reference/${refId}`,
    updateValueTable: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/admin/table/${tableId}`,
  },
  ADMIN_WORKFLOWS: {
    activateWorkflowDefinition: (projectId: number | string, definitionId: number | string) =>
      `api/admin/projects/${projectId}/workflows/${definitionId}/active`,
    createWorkflowDefinition: (projectId: number | string) => `api/admin/projects/${projectId}/workflows`,
    deactivateWorkflowDefinition: (projectId: number | string, definitionId: number | string) =>
      `api/admin/projects/${projectId}/workflows/${definitionId}/active`,
    getAdminWorkflowReactDiagram: (projectId: number | string, defId: number | string) =>
      `api/admin/projects/${projectId}/workflows/visualRD/${defId}`,
    getWorkflowDefinitionById: (projectId: number | string, definitionId: number | string) =>
      `api/admin/projects/${projectId}/workflows/${definitionId}`,
    getWorkflowDefinitions_1: (projectId: number | string) => `api/admin/projects/${projectId}/workflows`,
    getWorkflowReactDiagramFromMockup: (projectId: number | string) =>
      `api/admin/projects/${projectId}/workflows/visualRD/mockup`,
    updateWorkflowDefinition: (projectId: number | string, definitionId: number | string) =>
      `api/admin/projects/${projectId}/workflows/${definitionId}`,
  },
  AI_CHAT: {
    chat: (projectId: number | string, fileId: number | string) => `api/projects/${projectId}/ai/${fileId}/chat`,
    chatStream: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/ai/${fileId}/chat/stream`,
    validateConfiguration: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/ai/${fileId}/chat/validate`,
  },
  ANNOTATIONS: {
    addPdfSignature: (projectId: number | string) => `api/projects/${projectId}/easyviewer/signatures`,
    canBeMerged: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations/merge`,
    canBeMergedArchivFile: (projectId: number | string, fileId: number | string, archivFileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations/merge/${archivFileId}`,
    createAnnotatedPdf: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations/pdf`,
    createArchivedAnnotatedPdf: (projectId: number | string, fileId: number | string, archivFileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations/pdf/${archivFileId}`,
    deletePdfAnnotation: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations`,
    deletePdfSignature: (projectId: number | string, signatureId: number | string) =>
      `api/projects/${projectId}/easyviewer/signatures/${signatureId}`,
    downloadAnnotatedPdf: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations/pdf`,
    editPdfAnnotation: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations`,
    editPdfAnnotationsArchivFile: (
      projectId: number | string,
      fileId: number | string,
      archivFileId: number | string
    ) => `api/projects/${projectId}/easyviewer/${fileId}/annotations/${archivFileId}`,
    editPdfAnnotationsArchivFile_1: (
      projectId: number | string,
      fileId: number | string,
      archivFileId: number | string
    ) => `api/projects/${projectId}/easyviewer/${fileId}/annotations/${archivFileId}`,
    getPdfAnnotations: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations`,
    getPdfAnnotationsArchivFile: (projectId: number | string, fileId: number | string, archivFileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/annotations/${archivFileId}`,
    getPdfSignatures: (projectId: number | string) => `api/projects/${projectId}/easyviewer/signatures`,
  },
  AUTHENTICATIONS: {
    deleteJwt: (iduser: number | string, tokenId: number | string) => `api/users/${iduser}/token/${tokenId}`,
    deletePAVEUserJwt: (iduser: number | string, tokenId: number | string) =>
      `api/paveusers/${iduser}/token/${tokenId}`,
    deleteUserGoogleAuthenticator: (userId: number | string) => `api/users/${userId}/googleauth`,
    getUserGoogleAuthenticator: (userId: number | string) => `api/users/${userId}/googleauth`,
    getUserJwts: (userId: number | string) => `api/users/${userId}/token`,
  },
  AUTO_ORGANISER: {
    changeLabelsOfFileString: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/auto-organiser/${fileId}/labels`,
    createLabel: (projectId: number | string, modelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/label`,
    createLabelParent: (projectId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/labels/addparent`,
    createLabelType: (projectId: number | string, modelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/type`,
    createLabelTypeRelations: (projectId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/labels/addtype`,
    createModel: (projectId: number | string) => `api/projects/${projectId}/settings/auto-organiser/model`,
    createSynonymsForLabel: (projectId: number | string, modelId: number | string, labelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/synonym/${labelId}`,
    deleteLabel: (projectId: number | string, modelId: number | string, labelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/label/${labelId}`,
    deleteLabelSearchQuery: (projectId: number | string, queryId: number | string) =>
      `api/projects/${projectId}/auto-organiser/search/query/${queryId}`,
    deleteSynonym: (projectId: number | string, modelId: number | string, synonymId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/synonym/${synonymId}`,
    deleteType: (projectId: number | string, modelId: number | string, typeId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/type/${typeId}`,
    exportLabelModel: (projectId: number | string, modelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/export`,
    findFileLabelMapByLabels: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/search/file`,
    getAIModel: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/pave-ai/${fileId}/content`,
    getAIModel_1: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/model`,
    getAllModelsInProject: (projectId: number | string) => `api/projects/${projectId}/settings/auto-organiser/models`,
    getAllQueriesFromUser: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/search/query`,
    getDirectoryRules: (projectId: number | string) => `api/projects/${projectId}/settings/auto-organiser/rules`,
    getDirectoryRules_1: (projectId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/auto-organiser/rules/${dirId}`,
    getInheritedRule: (projectId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/auto-organiser/rules/${dirId}/inherited/extended`,
    getInheritedRuleOverall: (projectId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/auto-organiser/rules/${dirId}/inherited`,
    getLabelChildren: (projectId: number | string, labelId: number | string) =>
      `api/projects/${projectId}/auto-organiser/labels/${labelId}/children`,
    getLabelRelations: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/model/relation`,
    getLabelSearchQueryById: (projectId: number | string, queryId: number | string) =>
      `api/projects/${projectId}/auto-organiser/search/query/${queryId}`,
    getLabelSynonyms: (projectId: number | string, modelId: number | string, labelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/synonym/${labelId}`,
    getLabelTypeById: (projectId: number | string, modelId: number | string, typeId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/type/${typeId}`,
    getLabels: (projectId: number | string, modelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/labels`,
    getLabelsByType: (projectId: number | string, typeId: number | string) =>
      `api/projects/${projectId}/auto-organiser/types/${typeId}/labels`,
    getLabelsFromFile: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/auto-organiser/${fileId}/labels`,
    getLabels_1: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/labels`,
    getModelById: (projectId: number | string, modelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}`,
    getModelById_1: (projectId: number | string, modelId: number | string, labelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/label/${labelId}`,
    getSortedLabelModel: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/search/model`,
    getTypes: (projectId: number | string, modelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/types`,
    getTypes_1: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/types`,
    importLabelModel: (projectId: number | string) => `api/projects/${projectId}/settings/auto-organiser/model/import`,
    registerDirectoryRule: (projectId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/auto-organiser/rules/${dirId}`,
    saveLabelSearchQuery: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/search/query`,
    setLabelsToFile: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/labels/add/multiple`,
    setLabelsToFileString: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/auto-organiser/${fileId}/labels`,
    suggestDirectoriesToAllFiles: (projectId: number | string) => `api/projects/${projectId}/auto-organiser/evalall`,
    suggestDirectoriesToFile: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/auto-organiser/${fileId}/suggestdir`,
    suggestFilesToDirectory: (projectId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/auto-organiser/${dirId}/suggestfiles`,
    updateDirectoryRule: (projectId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/auto-organiser/rules/${dirId}`,
    updateLabel: (projectId: number | string, modelId: number | string, labelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/label/${labelId}`,
    updateLabelSearchQuery: (projectId: number | string, queryId: number | string) =>
      `api/projects/${projectId}/auto-organiser/search/query/${queryId}`,
    updateLabelType: (projectId: number | string, modelId: number | string, typeId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/type/${typeId}`,
    updateLabels: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/auto-organiser/${fileId}/labels`,
    updateModelName: (projectId: number | string, modelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}`,
    updateSynonym: (projectId: number | string, modelId: number | string, labelId: number | string) =>
      `api/projects/${projectId}/settings/auto-organiser/model/${modelId}/synonym/${labelId}`,
  },
  BCF: {
    getBcfFileContainer: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/bcfviewer/${fileId}`,
    getSingleTopicDetails: (projectId: number | string, fileId: number | string, topicGuid: number | string) =>
      `api/projects/${projectId}/bcfviewer/${fileId}/topics/${topicGuid}`,
    getSnapshotOfCommentForEasyViewer: (
      projectId: number | string,
      fileId: number | string,
      commentGuid: number | string
    ) => `api/projects/${projectId}/bcfviewer/${fileId}/topics/snapshot/${commentGuid}/easyviewer`,
  },
  BCF_SERVER_COMMENTS: {
    bcfServerDeleteComment: (project_id: number | string, topic_id: number | string, comment_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}`,
    bcfServerGetCommentById: (project_id: number | string, topic_id: number | string, comment_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}`,
    bcfServerGetComments: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments`,
    bcfServerPostComments: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments`,
    bcfServerPutComment: (project_id: number | string, topic_id: number | string, comment_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}`,
  },
  BCF_SERVER_DOCUMENTS: {
    bcfServerGetDocumentByGuid: (project_id: number | string, document_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/documents/${document_id}`,
    bcfServerGetDocuments: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}/documents`,
    bcfServerPostDocument: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}/documents`,
  },
  BCF_SERVER_DOCUMENTS_REFERENCES: {
    bcfServerGetDocumentReferences: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/document_references`,
    bcfServerPostDocumentReference: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/document_references`,
    bcfServerPutDocumentReference: (
      project_id: number | string,
      topic_id: number | string,
      document_reference_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/document_references/${document_reference_id}`,
  },
  BCF_SERVER_EVENTS: {
    bcfServerGetCommentEvents: (project_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/comments/events`,
    bcfServerGetCommentEventsByCommentId: (
      project_id: number | string,
      topic_id: number | string,
      comment_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}/events`,
    bcfServerGetTopicEvents: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}/topics/events`,
    bcfServerGetTopicEventsByTopicId: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/events`,
  },
  BCF_SERVER_EXTENSIONS: {
    bcfServerAddIfcModelToTopic: (projectId: number | string, topicGuid: number | string, fileId: number | string) =>
      `api/projects/${projectId}/bcf-ext/${topicGuid}/${fileId}`,
    bcfServerAddProjectFile: (projectId: number | string, topicGuid: number | string) =>
      `api/projects/${projectId}/bcf-ext/${topicGuid}/attachments`,
    bcfServerDeleteTopics: (projectId: number | string) => `api/projects/${projectId}/bcf-ext/delete_topics`,
    bcfServerGetAllTopicsWithIfcProjects: (projectId: number | string) =>
      `api/projects/${projectId}/bcf-ext/topics_with_ifc`,
    bcfServerGetAttachments: (projectId: number | string, topicGuid: number | string) =>
      `api/projects/${projectId}/bcf-ext/${topicGuid}/attachments`,
    bcfServerGetTopicFileInfo: (projectId: number | string, topicGuid: number | string) =>
      `api/projects/${projectId}/bcf-ext/${topicGuid}/files`,
    bcfServerGetTopicsByFileId: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/bcf-ext/${fileId}`,
    bcfServerGetTopicsWithThumbnails: (projectId: number | string) =>
      `api/projects/${projectId}/bcf-ext/topics_with_thumbnails`,
    bcfServerGetTopicsWithThumbnails_1: (projectId: number | string, topicGuid: number | string) =>
      `api/projects/${projectId}/bcf-ext/thumbnail/${topicGuid}`,
    bcfServerMultiUpdateTopics: (projectId: number | string) => `api/projects/${projectId}/bcf-ext/update_topics`,
    bcfServerRelinkTopicFile: (projectId: number | string, topicGuid: number | string, fileId: number | string) =>
      `api/projects/${projectId}/bcf-ext/${topicGuid}/relink/${fileId}`,
    bcfServerRemoveAttachments: (projectId: number | string, topicGuid: number | string) =>
      `api/projects/${projectId}/bcf-ext/${topicGuid}/attachments`,
    bcfServerRemoveProjectFile: (projectId: number | string, topicGuid: number | string) =>
      `api/projects/${projectId}/bcf-ext/${topicGuid}/deleteFile`,
    bcfServerRestoreTopics: (projectId: number | string) => `api/projects/${projectId}/bcf-ext/restore_topics`,
    exportBcfData: (projectId: number | string) => `api/projects/${projectId}/bcf-ext/export`,
    importBcfData: (projectId: number | string) => `api/projects/${projectId}/bcf-ext/import`,
    importBcfDataWithTempFile: (projectId: number | string) => `api/projects/${projectId}/bcf-ext/import/temp`,
  },
  BCF_SERVER_FILES: {
    bcfServerGetFileInformation: (project_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/files_information`,
    bcfServerGetTopicFiles: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/files`,
    bcfServerPutTopicFiles: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/files`,
  },
  BCF_SERVER_PROJECTS: {
    bcfServerGetProjectByGuid: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}`,
    bcfServerGetProjectExtensions: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}/extensions`,
    bcfServerGetProjects: () => `api/bcf/3.0/projects`,
    bcfServerPutProject: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}`,
  },
  BCF_SERVER_RELATED_TOPICS: {
    bcfServerGetRelatedTopics: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/related_topics`,
    bcfServerPutRelatedTopics: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/related_topics`,
  },
  BCF_SERVER_SNIPPETS: {
    bcfServerGetSnippetById: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/snippet`,
    bcfServerPutSnippet: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/snippet`,
  },
  BCF_SERVER_TOPICS: {
    bcfServerDeleteTopic: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}`,
    bcfServerGetTopicById: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}`,
    bcfServerGetTopics: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}/topics`,
    bcfServerPostTopic: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}/topics`,
    bcfServerPutTopicById: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}`,
  },
  BCF_SERVER_TOPICS_FILTER: {
    bcfServerDeleteFilterSetting: (project_id: number | string, settingId: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/filter/settings/${settingId}`,
    bcfServerFilterTopics: (project_id: number | string) => `api/bcf/3.0/projects/${project_id}/topics/filter`,
    bcfServerGetFilterSettings: (project_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/filter/settings`,
    bcfServerPostFilterSetting: (project_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/filter/settings`,
    bcfServerPutFilterSetting: (project_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/filter/settings`,
  },
  BCF_SERVER_VIEWPOINTS: {
    bcfServerDeleteViewpoint: (project_id: number | string, topic_id: number | string, viewpoint_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}`,
    bcfServerGetViewpointBitmap: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string,
      bitmap_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/bitmaps/${bitmap_id}`,
    bcfServerGetViewpointById: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}`,
    bcfServerGetViewpointColoring: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/coloring`,
    bcfServerGetViewpointSelection: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/selection`,
    bcfServerGetViewpointSnapshot: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/snapshot`,
    bcfServerGetViewpointVisibility: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/visibility`,
    bcfServerGetViewpoints: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints`,
    bcfServerPostViewpoint: (project_id: number | string, topic_id: number | string) =>
      `api/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints`,
  },
  BIM: {
    getXktFile: (projectId: number | string, fileId: number | string, uniqueId: number | string) =>
      `api/projects/${projectId}/bim/${fileId}/${uniqueId}/xkt`,
    metaObjectTypes: (projectId: number | string, fileId: number | string, uniqueId: number | string) =>
      `api/projects/${projectId}/bim/${fileId}/${uniqueId}/search/metaObjectTypes`,
    metaObjects: (projectId: number | string, fileId: number | string, uniqueId: number | string) =>
      `api/projects/${projectId}/bim/${fileId}/${uniqueId}/search/metaObjects`,
    propertyTypes: (projectId: number | string, fileId: number | string, uniqueId: number | string) =>
      `api/projects/${projectId}/bim/${fileId}/${uniqueId}/search/propertyTypes`,
  },
  BIM_COLLAB: {
    deleteBimCollabAuthInfo: (projectId: number | string) => `api/projects/${projectId}/bim-collab/auth_info`,
    getBimCollabOAuthInfo: (projectId: number | string) => `api/projects/${projectId}/bim-collab/auth_info`,
    getBimCollabOAuthUrl: (projectId: number | string) => `api/projects/${projectId}/bim-collab/oauth`,
    getBimCollabProjects: (projectId: number | string) => `api/projects/${projectId}/bim-collab/projects`,
    updateBimCollabAuthInfo: (projectId: number | string) => `api/projects/${projectId}/bim-collab/auth_info`,
    updateBimCollabURL: (projectId: number | string) => `api/projects/${projectId}/bim-collab/url`,
  },
  BOX: {
    getBoxConnectionInfo: (projectId: number | string) => `api/box/${projectId}/settings`,
    updateBoxConnectionInfo: (projectId: number | string) => `api/box/${projectId}/settings`,
  },
  CALENDAR: {
    deleteEvent: (projectId: number | string, eventId: number | string) =>
      `api/projects/${projectId}/calendar/events/${eventId}`,
    getEvent: (projectId: number | string, eventId: number | string) =>
      `api/projects/${projectId}/calendar/events/${eventId}`,
    getEvents: (projectId: number | string) => `api/projects/${projectId}/calendar/events/search`,
    saveEvent: (projectId: number | string) => `api/projects/${projectId}/calendar/events`,
    updateEvent: (projectId: number | string, eventId: number | string) =>
      `api/projects/${projectId}/calendar/events/${eventId}`,
  },
  CALLBACK: {
    storeBimCollabAuthInfo: () => `api/callback/bimcollab`,
  },
  CATEGORIES: {
    getCategories: (projectId: number | string) => `api/projects/${projectId}/categories/list`,
    getData: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/categories/folders/${folderId}`,
    getRoot: (projectId: number | string) => `api/projects/${projectId}/categories/folders`,
    updateCategory: (projectId: number | string, categoryId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/categories/${categoryId}/${fileId}`,
  },
  CFT_OFFER: {
    getOffer: (callId: number | string) => `api/tender/${callId}/offer`,
    getOfferStatus: (callId: number | string) => `api/tender/${callId}/offerStatus`,
    makeOffer: (callId: number | string) => `api/tender/${callId}/offer`,
    updateOffer: (callId: number | string) => `api/tender/${callId}/offer`,
  },
  CONTACTS: {
    create: (projectId: number | string) => `api/projects/${projectId}/contacts`,
    createFromFile: (projectId: number | string) => `api/projects/${projectId}/contacts/import.excel`,
    delete: (projectId: number | string, contactId: number | string) =>
      `api/projects/${projectId}/contacts/${contactId}`,
    exportContacts: (projectId: number | string) => `api/projects/${projectId}/users/export.excel`,
    getContactCard: (projectId: number | string, contactId: number | string) =>
      `api/projects/${projectId}/contacts/${contactId}/vcard`,
    getContacts: (projectId: number | string) => `api/projects/${projectId}/contacts`,
    getContactsAsFile: (projectId: number | string, contactType: number | string) =>
      `api/projects/${projectId}/contacts/export.excel/${contactType}`,
    update: (projectId: number | string, contactId: number | string) =>
      `api/projects/${projectId}/contacts/${contactId}`,
  },
  DISCLAIMER: {
    agreeToDisclaimer: (projectId: number | string, disclaimerId: number | string) =>
      `api/projects/${projectId}/disclaimer/${disclaimerId}`,
    changeDisclaimer: (projectId: number | string) => `api/projects/${projectId}/disclaimer`,
    createDisclaimer: (projectId: number | string) => `api/projects/${projectId}/disclaimer`,
    getDisclaimer: (projectId: number | string) => `api/projects/${projectId}/disclaimer`,
  },
  DISTRIBUTION: {
    loadVersion: (projectId: number | string, versionNr: number | string) =>
      `api/projects/${projectId}/distributionmatrix/version/${versionNr}`,
    loadVersionInfo: (projectId: number | string) => `api/projects/${projectId}/distributionmatrix`,
    resetEditLock: (projectId: number | string) => `api/projects/${projectId}/distributionmatrix/releaselock`,
    save: (projectId: number | string) => `api/projects/${projectId}/distributionmatrix`,
  },
  DOCNODES: {
    getDocNodesInfo: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/docnodes`,
  },
  DOCUMENTS: {
    getDocumentByFileId: (projectId: number | string, folderId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/documents/${folderId}/${fileId}`,
    getDocumentsByFolderId: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/documents/${folderId}`,
    getDocumentsOfRootFolder: (projectId: number | string) => `api/projects/${projectId}/documents`,
  },
  DOCUMENTS_API_DOWNLOAD: {
    documentApiSaveUsersSelection: () => `api/opencde/documents/v1/document-selection`,
    documentsApiDownloadDocument: (documentGuid: number | string) =>
      `api/opencde/documents/v1/${documentGuid}/download`,
    documentsApiGetDocumentMetadata: (documentGuid: number | string) =>
      `api/opencde/documents/v1/${documentGuid}/metadata`,
    documentsApiGetDocumentVersion: (documentGuid: number | string) =>
      `api/opencde/documents/v1/${documentGuid}/version`,
    documentsApiGetDocumentVersions: (documentGuid: number | string) =>
      `api/opencde/documents/v1/${documentGuid}/versions`,
    documentsApiGetUsersSelection: () => `api/opencde/documents/v1/download-instructions`,
    documentsApiInitiateDownload: () => `api/opencde/documents/v1/select-documents`,
  },
  DOCUMENTS_API_UPLOAD: {
    documentsApiCancelUpload: () => `api/opencde/documents/v1/cancel-upload`,
    documentsApiCompleteUpload: () => `api/opencde/documents/v1/upload-completion`,
    documentsApiEnterMetadata: () => `api/opencde/documents/v1/document-metadata`,
    documentsApiGetUploadInstructions: () => `api/opencde/documents/v1/upload-instructions`,
    documentsApiInitiateDownload_1: () => `api/opencde/documents/v1/upload-documents`,
    documentsApiUploadFile: (session_file_id: number | string) =>
      `api/opencde/documents/v1/upload-chunk/${session_file_id}`,
  },
  EXTERN_DOMAINS: {
    addWhitelistedDomain: () => `api/extern-domains`,
    deleteWhiteListedDomain: () => `api/extern-domains`,
    getAllWhitelisted: () => `api/extern-domains`,
  },
  FEATURE_FLAGS: {
    getMyFeatures: () => `api/features/me`,
    getProjectFeatures: (projectId: number | string) => `api/projects/${projectId}/features`,
  },
  FEATURE_FLAGS_ADMIN: {
    createAssignment: (id: number | string) => `api/admin/feature-flags/${id}/assignments`,
    createFlag: () => `api/admin/feature-flags`,
    deleteAssignment: (assignmentId: number | string) => `api/admin/feature-flags/assignments/${assignmentId}`,
    listAssignments: (id: number | string) => `api/admin/feature-flags/${id}/assignments`,
    listAudit: () => `api/admin/feature-flags/audit`,
    listFlags: () => `api/admin/feature-flags`,
    updateAssignment: (assignmentId: number | string) => `api/admin/feature-flags/assignments/${assignmentId}`,
    updateFlag: (id: number | string) => `api/admin/feature-flags/${id}`,
  },
  FILES: {
    changeFileOwner: (projectId: number | string) => `api/projects/${projectId}/files/owner`,
    changeObject: (projectId: number | string, fileId: number | string, objectId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/objects/${objectId}`,
    checkFiles: (projectId: number | string, dirid: number | string) =>
      `api/projects/${projectId}/fileUpload/check/${dirid}`,
    cleanupTmpDirV2: (projectId: number | string) => `api/projects/${projectId}/fileUpload/delete`,
    createSymlink: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/files/symlink/${folderId}`,
    deleteFiles_1: (projectId: number | string) => `api/projects/${projectId}/files/deleteFiles`,
    deleteObject: (projectId: number | string, fileId: number | string, objectId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/objects/${objectId}`,
    deleteSymlink: (projectId: number | string, fileId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/symlink/${dirId}`,
    extractZip: (projectId: number | string, dirid: number | string) =>
      `api/projects/${projectId}/fileUpload/extract/${dirid}`,
    getAllFileOwners: (projectId: number | string) => `api/projects/${projectId}/files/owners`,
    getArchiveFileById: (projectId: number | string, fileId: number | string, archivedId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/archive/${archivedId}`,
    getDownloadWizard2Response: (projectId: number | string) => `api/projects/${projectId}/files/downloadWizard`,
    getExcelCustomFileList: (projectId: number | string) => `api/projects/${projectId}/files/excel/custom`,
    getExcelFileList: (projectId: number | string) => `api/projects/${projectId}/files/excel`,
    getExcelFileLog: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/log.excel`,
    getFileAccessHistory: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/access-history`,
    getFileById: (projectId: number | string, fileId: number | string) => `api/projects/${projectId}/files/${fileId}`,
    getFileByIdAndUniqueId: (projectId: number | string, fileId: number | string, uniqueId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/uniqueId/${uniqueId}`,
    getFileExcelReport: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/access-history/excel`,
    getFileLog: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/log`,
    getFileMetadataForEdit: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/metadataForEdit`,
    getFileMetadata_1: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/metadata`,
    getFilePdfReport: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/access-history/pdf`,
    getFilePreview: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/preview`,
    getFilenameAssistentRequest: (projectId: number | string) => `api/projects/${projectId}/filenameConvention`,
    getFiles: (projectId: number | string) => `api/projects/${projectId}/files/downloadmultiple`,
    getFilesExcelExportOptions: (projectId: number | string) => `api/projects/${projectId}/files/excel/options`,
    getIdentifiedObjects: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/objects`,
    getPdfFilesByIdAsZip: (projectId: number | string) => `api/projects/${projectId}/files/pdf`,
    getRefreshedFiles_1: (projectId: number | string) => `api/projects/${projectId}/files/refresh`,
    getRelationInfoWithDirecotry: (projectId: number | string, fileId: number | string, dirId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/relations/${dirId}`,
    getTaskStatus: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/task-status`,
    getTerms: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/terms`,
    getTopics: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/topics`,
    getVersionsInfo_1: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/versions`,
    lockFile: (projectId: number | string, folderId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${folderId}/${fileId}/lock`,
    moveAttachmentFromMailStart: (projectId: number | string) => `api/projects/${projectId}/fileUpload/moveFromMail`,
    moveFiles_1: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/files/parent/${folderId}`,
    persistFiles: (projectId: number | string, dirid: number | string) =>
      `api/projects/${projectId}/fileUpload/doc/${dirid}`,
    prepareTempFiles: (projectId: number | string, dirid: number | string) =>
      `api/projects/${projectId}/fileUpload/upload/${dirid}/temp`,
    restoreFile_1: (projectId: number | string) => `api/projects/${projectId}/files/restore`,
    thirdPartyGetFilenameAssistantRequest: (projectId: number | string) =>
      `api/apps/v1/project/${projectId}/filenameConvention`,
    unlockFiles: (projectId: number | string, folderId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${folderId}/${fileId}/lock`,
    updateFileDetails: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}`,
    updateFileMetadataForEdit: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/metadataForEdit`,
    updateMultipleFileDetails: (projectId: number | string) => `api/projects/${projectId}/files`,
    uploadEVAnnotatedPdfToWorkflow: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/ev-annotated-pdf`,
    uploadFileToFolder_1: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/fileUpload/${folderId}`,
    uploadFilesToProject: (projectId: number | string) => `api/projects/${projectId}/files`,
    uploadFilesToTempDirectory: (projectId: number | string) =>
      `api/projects/${projectId}/templates/uploadUsingTemplate`,
    uploadPdfToWorkflow: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/annotated-pdf`,
  },
  FILE_UPLOAD_V3: {
    deleteTemporaryFile: (projectId: number | string, temporaryFileId: number | string) =>
      `api/projects/${projectId}/uploads/${temporaryFileId}`,
    listTemporaryFiles: (projectId: number | string) => `api/projects/${projectId}/uploads`,
    uploadTemporaryFile: (projectId: number | string) => `api/projects/${projectId}/uploads`,
  },
  FOLDERS: {
    addFolderRights: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/rights`,
    applyChanges: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/rightsmatrix/${folderId}/update`,
    checkUpdates: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/rightsmatrix/${folderId}/check`,
    copyDirectory: (projectId: number | string) => `api/projects/${projectId}/folders/copy`,
    copyFolderRights: (projectId: number | string, sourceFolderId: number | string) =>
      `api/projects/${projectId}/folders/${sourceFolderId}/rights/copy`,
    createFolders: (projectId: number | string) => `api/projects/${projectId}/folders`,
    createSymlinkForDirectory: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/symlink`,
    deleteFolder_1: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}`,
    deleteLinkedFolder: (projectId: number | string, linkId: number | string) =>
      `api/projects/${projectId}/folders/symlink/${linkId}`,
    deleteProjectMailAccessRight: (projectId: number | string, folderId: number | string, accessId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/rights/${accessId}`,
    expandAllSubfoldersForMatrixFolder: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/rightsmatrix/${folderId}/expand-all`,
    getActiveItemsCountForDelete: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/countFolderContentForDelete`,
    getAvailableFolderRights: (projectId: number | string) => `api/projects/${projectId}/folders/rights`,
    getAvailableFolderRights_1: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/rightsmatrix/${folderId}`,
    getBreadcrumbs: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/breadcrumbs`,
    getExcelRightsMatrix: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/rightsmatrix/${folderId}/excel`,
    getFolderMetadata: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/metadata`,
    getFolderRelations: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/relations`,
    getFolderRights: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/rights`,
    getFolderUserRights: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/userRights`,
    getFullPath: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/path`,
    getFullPathForExternalLink: (projectId: number | string, linkId: number | string) =>
      `api/projects/${projectId}/linked/${linkId}/path`,
    getFullTree: (projectId: number | string) => `api/projects/${projectId}/folders/full`,
    getPossibleTargetsForCreatingSymlinks: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/symlink/targets`,
    getProjectFolderMetadataOverview: (projectId: number | string) =>
      `api/projects/${projectId}/folders/metadata-overview`,
    getSubdirsForExternalLink: (projectId: number | string, linkId: number | string) =>
      `api/projects/${projectId}/linked/${linkId}/subdirs`,
    getSubfolders: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/subdirs`,
    getSubfoldersForMatrixFolder: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/rightsmatrix/${folderId}/subfolders`,
    getTreeFromPath: (projectId: number | string) => `api/projects/${projectId}/folders/subdirs`,
    getTreeRoot: (projectId: number | string) => `api/projects/${projectId}/folders/rootdirs`,
    moveFolder_1: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/parent`,
    renameFolder: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/name`,
    restoreFolder: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}`,
    updateFolderMetadata: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/folders/${folderId}/metadata`,
  },
  FOUNDATION_API: {
    getAuthInformation: () => `api/foundation/1.0/auth`,
    getBcfAuthInformation: () => `api/bcf/2.1/auth`,
    getCurrentUser: () => `api/foundation/1.0/current-user`,
    getFoundationVersions: () => `api/foundation/versions`,
  },
  FTS: {
    deleteIndexesForProject: (projectId: number | string) => `api/projects/${projectId}/fts/delete`,
    highlightsForTerm: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/fts/highlights/${fileId}`,
    reinitializeIndex: (projectId: number | string) => `api/projects/${projectId}/fts/reinitialize`,
    searchForTerm: (projectId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/fts/search/${folderId}`,
  },
  GROUPS: {
    assignGroupsToGroup: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/groups/${id}/groupMembers`,
    assignMembersToGroup: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/groups/${id}/members`,
    createGroup: (projectId: number | string) => `api/projects/${projectId}/groups`,
    editGroup: (projectId: number | string, id: number | string) => `api/projects/${projectId}/groups/${id}`,
    getGroup: (projectId: number | string, id: number | string) => `api/projects/${projectId}/groups/${id}`,
    getGroupMatrixAsExcel: (projectId: number | string) => `api/projects/${projectId}/groups/groups.excel`,
    getGroupMembers: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/groups/${id}/members`,
    getGroupsWithoutOrganisations: (projectId: number | string) => `api/projects/${projectId}/groups/public`,
    getOrganisationsOfProject: (projectId: number | string) => `api/projects/${projectId}/groups`,
    getUnassignedGroupMembers: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/groups/${id}/unassignedMembers`,
    getUnassignedGroups: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/groups/${id}/unassignedGroups`,
    unassignContactFromGroup: (projectId: number | string, id: number | string, idContact: number | string) =>
      `api/projects/${projectId}/groups/${id}/contacts/${idContact}`,
    unassignGroupFromGroup: (projectId: number | string, id: number | string, subGroupId: number | string) =>
      `api/projects/${projectId}/groups/${id}/groups/${subGroupId}`,
    unassignUserFromGroup: (projectId: number | string, id: number | string, idUser: number | string) =>
      `api/projects/${projectId}/groups/${id}/users/${idUser}`,
  },
  GUEST: {
    getGuestAccesses: (projectId: number | string) => `api/projects/${projectId}/guestaccess`,
    resetGuestAccesses: (projectId: number | string, accessId: number | string) =>
      `api/projects/${projectId}/guestaccess/${accessId}/reset`,
    revokeGuestAccesses: (projectId: number | string, accessId: number | string) =>
      `api/projects/${projectId}/guestaccess/${accessId}/revoke`,
    unlockGuestAccesses: (projectId: number | string, accessId: number | string) =>
      `api/projects/${projectId}/guestaccess/${accessId}/unlock`,
  },
  HISTORY: {
    getLast: () => `api/history/user`,
  },
  IFC: {
    filterPropertiesDetailed: (prid: number | string, fileId: number | string) =>
      `api/projects/${prid}/ifc/search/properties/${fileId}`,
    getIfcForSearch: (prid: number | string, fileId: number | string) => `api/projects/${prid}/ifc/search/${fileId}`,
    getPlainIfcFileContent: (prid: number | string, fileId: number | string) =>
      `api/projects/${prid}/ifc/plain/${fileId}`,
    getPreprocessedIfcFileContent: (prid: number | string, fileId: number | string) =>
      `api/projects/${prid}/ifc/preprocessed/${fileId}`,
    readExtractedFileContent: (prid: number | string, fileId: number | string) =>
      `api/projects/${prid}/ifc/read/${fileId}`,
    searchInIfc: (prid: number | string, fileId: number | string) => `api/projects/${prid}/ifc/search/${fileId}`,
    searchInIfcExtended: (prid: number | string, fileId: number | string) =>
      `api/projects/${prid}/ifc/search/extended/${fileId}`,
  },
  IFCSERVICE: {
    downloadFile: (idpr: number | string, id: number | string, uniqueid: number | string) =>
      `api/ifcservice/project/${idpr}/file/${id}/unique/${uniqueid}`,
  },
  INFO: {
    getCustomerInfo_1: () => `api/customer-info`,
  },
  KPI: {
    createConfig: (projectId: number | string) => `api/projects/${projectId}/kpi`,
    deleteConfig: (projectId: number | string, configId: number | string) =>
      `api/projects/${projectId}/kpi/${configId}`,
    exportAsExcel: (projectId: number | string, configId: number | string) =>
      `api/projects/${projectId}/kpi/${configId}/export`,
    getAllCharts: (projectId: number | string) => `api/projects/${projectId}/kpi`,
    getConfig: (projectId: number | string, configId: number | string) => `api/projects/${projectId}/kpi/${configId}`,
    reorderDashboards: (projectId: number | string) => `api/projects/${projectId}/kpi/reorder`,
    updateConfig: (projectId: number | string, configId: number | string) =>
      `api/projects/${projectId}/kpi/${configId}`,
  },
  LINKED: {
    getEasyViewerExternalLinkedFile: (projectId: number | string, linkId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/linked/${linkId}/${fileId}/easyviewer`,
    getEasyViewerExternalLinkedFileSize: (
      projectId: number | string,
      linkId: number | string,
      fileId: number | string
    ) => `api/projects/${projectId}/linked/${linkId}/${fileId}/easyviewer`,
    getWebViewerExternalLinkedFile: (projectId: number | string, linkId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/linked/${linkId}/${fileId}/webviewer`,
    readLinkedFile: (projectId: number | string, linkId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/linked/${linkId}/${fileId}`,
    readLinkedFolder: (projectId: number | string, linkId: number | string) =>
      `api/projects/${projectId}/linked/${linkId}`,
  },
  LOGIN: {
    finalizeMultistepLogin: (accessToken: number | string) => `api/login/direct/${accessToken}`,
    getAuthUrl: () => `api/login/oauth2/authUrl`,
    getQRCode: () => `api/login/initialize`,
    getSettings: () => `api/login/settings`,
    getStatus: () => `api/login/status`,
    initializeMultistepLogin: () => `api/login/direct`,
    loginUserExternPrimary: () => `api/login/extern`,
    loginUserMain: () => `api/login`,
    loginWithOauth2: (serverId: number | string) => `api/login/oauth2/${serverId}`,
    logoutUser: () => `api/login`,
    thirdPartyLogoutUser: () => `api/apps/v1/login`,
    validateUserpassword: () => `api/login/validate`,
  },
  LOP: {
    addEntry: (prid: number | string, lopId: number | string) => `api/projects/${prid}/lop/${lopId}`,
    createAcl: (prid: number | string, lopId: number | string) => `api/projects/${prid}/lop/${lopId}/acl`,
    createLOP: (prid: number | string) => `api/projects/${prid}/lop`,
    deleteAcl: (prid: number | string, lopId: number | string, aclId: number | string) =>
      `api/projects/${prid}/lop/${lopId}/acl/${aclId}`,
    deleteEntry: (prid: number | string, lopId: number | string, pointId: number | string) =>
      `api/projects/${prid}/lop/${lopId}/${pointId}`,
    getAllAcl: (prid: number | string, lopId: number | string) => `api/projects/${prid}/lop/${lopId}/acl`,
    getEffectiveUserRights: (prid: number | string, lopId: number | string) =>
      `api/projects/${prid}/lop/${lopId}/userRights`,
    getEntry: (prid: number | string, lopId: number | string, pointId: number | string) =>
      `api/projects/${prid}/lop/${lopId}/${pointId}`,
    getLOP: (prid: number | string, lopId: number | string) => `api/projects/${prid}/lop/${lopId}`,
    getLOPExcel: (prid: number | string, lopId: number | string) => `api/projects/${prid}/lop/${lopId}/excel`,
    getProjectLOPs: (prid: number | string) => `api/projects/${prid}/lop`,
    search: (prid: number | string, lopId: number | string) => `api/projects/${prid}/lop/searchlop/${lopId}`,
    updateAcl: (prid: number | string, lopId: number | string, aclId: number | string) =>
      `api/projects/${prid}/lop/${lopId}/acl/${aclId}`,
    updateEntry: (prid: number | string, lopId: number | string, pointId: number | string) =>
      `api/projects/${prid}/lop/${lopId}/${pointId}`,
    updateLOP: (prid: number | string, lopId: number | string) => `api/projects/${prid}/lop/${lopId}`,
    updatePointPositions: (prid: number | string, lopId: number | string) =>
      `api/projects/${prid}/lop/${lopId}/position`,
  },
  MAILS: {
    archive: (projectId: number | string, type: number | string) => `api/projects/${projectId}/mails/${type}/archive`,
    checkAttachment: (
      projectId: number | string,
      type: number | string,
      mailId: number | string,
      folderId: number | string
    ) => `api/projects/${projectId}/mails/${type}/${mailId}/checkAttachment/${folderId}`,
    cloneDraft: (projectId: number | string, type: number | string, mailId: number | string) =>
      `api/projects/${projectId}/mails/${type}/clone/${mailId}`,
    delete_1: (projectId: number | string, type: number | string) => `api/projects/${projectId}/mails/${type}`,
    editDraft: (projectId: number | string, type: number | string) => `api/projects/${projectId}/mails/${type}/edit`,
    getAllMailsByType: (projectId: number | string, type: number | string) =>
      `api/projects/${projectId}/mails/${type}/select-all`,
    getFilenamesForMails: (projectId: number | string) => `api/projects/${projectId}/mails/filenames`,
    getGuestMailAttachments: (accessId: number | string) => `api/mails/${accessId}/attachments`,
    getMail: (projectId: number | string, type: number | string, mailId: number | string) =>
      `api/projects/${projectId}/mails/${type}/${mailId}`,
    getMailById: (projectId: number | string, mailId: number | string) =>
      `api/projects/${projectId}/mails/${mailId}/content`,
    getMails: (projectId: number | string, type: number | string) => `api/projects/${projectId}/mails/${type}`,
    getPdf: (projectId: number | string) => `api/projects/${projectId}/mails/pdf`,
    getProjectMailAccessRights: (projectId: number | string) => `api/projects/${projectId}/mails/access`,
    move: (projectId: number | string) => `api/projects/${projectId}/mails/move`,
    moveAttachment: (
      projectId: number | string,
      type: number | string,
      mailId: number | string,
      folderId: number | string
    ) => `api/projects/${projectId}/mails/${type}/${mailId}/moveAttachment/${folderId}`,
    moveAttachmentToProject: (
      projectId: number | string,
      type: number | string,
      mailId: number | string,
      folderId: number | string
    ) => `api/projects/${projectId}/mails/${type}/${mailId}/attachment/${folderId}`,
    restore: (projectId: number | string, type: number | string) => `api/projects/${projectId}/mails/${type}/restore`,
    search_1: (projectId: number | string) => `api/projects/${projectId}/mails/search`,
    send: (projectId: number | string) => `api/projects/${projectId}/mails`,
    unread: (projectId: number | string) => `api/projects/${projectId}/mails/unread`,
    updateProjectMailAccessRight: (projectId: number | string) => `api/projects/${projectId}/mails/access`,
  },
  MAIL_ARCHIVE: {
    importMail: () => `api/mails`,
  },
  MCP: {
    getQuotaConfig: () => `api/mcp/quota-config`,
    listVisibility: () => `api/mcp/visibility`,
    recordHeartbeat: () => `api/mcp/visibility`,
  },
  MCP_ADMIN: {
    deleteClient: (id: number | string) => `api/apps/v1/admin/mcp-clients/${id}`,
    deleteQuotaOverride: (id: number | string) => `api/apps/v1/admin/mcp-quota/overrides/${id}`,
    deleteRegistrationsLast24h: () => `api/apps/v1/admin/mcp-registrations`,
    getAdmission: () => `api/apps/v1/admin/mcp-clients/admission`,
    getClients: () => `api/apps/v1/admin/mcp-clients`,
    getConnections: () => `api/apps/v1/admin/mcp-connections`,
    getMcpOverview: () => `api/apps/v1/admin/mcp-overview`,
    getQuotaPolicy: () => `api/apps/v1/admin/mcp-quota`,
    getRegistrationsLast24h: () => `api/apps/v1/admin/mcp-registrations`,
    updateAdmission: () => `api/apps/v1/admin/mcp-clients/admission`,
    updateClient: () => `api/apps/v1/admin/mcp-clients`,
    updateQuotaDefaults: () => `api/apps/v1/admin/mcp-quota/defaults`,
    upsertClient: () => `api/apps/v1/admin/mcp-clients`,
    upsertQuotaOverride: () => `api/apps/v1/admin/mcp-quota/overrides`,
  },
  MEETINGS: {
    addMeetingParticipant: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/participants`,
    cancelMeetingItem: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/cancel`,
    createMeetingAgendaItem: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/items`,
    createMeetingAgendaTopics: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/topics`,
    createMeetingItem: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings`,
    createMeetingSeries: (projectId: number | string) => `api/projects/${projectId}/meeting-series`,
    createMeetingSeriesAccessRights: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/access`,
    deleteMeetingAgendaItem: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      itemId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/items/${itemId}`,
    deleteMeetingAgendaTopic: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      topicId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/topics/${topicId}`,
    deleteMeetingItem: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}`,
    deleteMeetingParticipant: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/participants/remove`,
    deleteMeetingSeries: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}`,
    deleteMeetingSeriesAccessRights: (
      projectId: number | string,
      seriesId: number | string,
      accessEntryId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/access/${accessEntryId}`,
    editMeetingAgendaItem: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      itemId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/items/${itemId}`,
    editMeetingAgendaItems: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/items`,
    editMeetingAgendaTopics: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/topics`,
    editMeetingItem: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}`,
    editMeetingSeries: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}`,
    editMeetingSeriesAccessRights: (
      projectId: number | string,
      seriesId: number | string,
      accessEntryId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/access/${accessEntryId}`,
    finalizeMeetingItem: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/finish`,
    getMeetingAgendaList: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda`,
    getMeetingItemsList: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings`,
    getMeetingParticipantsList: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/participants`,
    getMeetingProtocol: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/protocol`,
    getMeetingProtocolById: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      protocolId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/protocol/${protocolId}`,
    getMeetingSeriesById: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}`,
    getMeetingSeriesEffectiveRights: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/userRights`,
    getMeetingSeriesItemById: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}`,
    getMeetingSeriesList: (projectId: number | string) => `api/projects/${projectId}/meeting-series`,
    getMeetingSeriesListAccessRights: (projectId: number | string, seriesId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/access`,
    reorderMeetingAgendaItems: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      itemId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/items/${itemId}/reorder`,
    reorderMeetingAgendaTopics: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      topicId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/agenda/topics/${topicId}/reorder`,
    searchMeetingAgendaItems: (projectId: number | string) => `api/projects/${projectId}/meeting-series/search`,
    setMeetingLeader: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/participants/leader`,
  },
  MEETING_DOCUMENTS: {
    attachMeetingDocument: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/documents`,
    deleteMeetingDocument: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      documentId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/documents/${documentId}`,
    getMeetingDocuments: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/documents`,
    getMeetingProtocolsList: (projectId: number | string, seriesId: number | string, meetingId: number | string) =>
      `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/documents/protocols`,
    renameMeetingDocument: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      documentId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/documents/${documentId}`,
    restoreMeetingDocument: (
      projectId: number | string,
      seriesId: number | string,
      meetingId: number | string,
      documentId: number | string
    ) => `api/projects/${projectId}/meeting-series/${seriesId}/meetings/${meetingId}/documents/restore/${documentId}`,
  },
  METADATA: {
    getAllMetadataAsExcel: (projectId: number | string) => `api/admin/projects/${projectId}/metadata/export`,
    getDefinitions: (projectId: number | string) => `api/projects/${projectId}/metadata/definitions`,
    getDefinitionsFull: (projectId: number | string) => `api/projects/${projectId}/metadata/definitionsfull`,
    importMetadataFromExcel: (projectId: number | string) => `api/admin/projects/${projectId}/metadata/import`,
    thirdPartyGetDefinitionsFull: (projectId: number | string) =>
      `api/apps/v1/project/${projectId}/metadata/definitionsfull`,
    updateProjectMetadata_1: (projectId: number | string, metadataId: number | string) =>
      `api/projects/${projectId}/metadata/${metadataId}`,
  },
  NOTIFICATIONS: {
    getLast_1: () => `api/notifications`,
  },
  NUMBERING: {
    changePosition: (projectId: number | string, parendDirId: number | string) =>
      `api/projects/${projectId}/numbering/${parendDirId}/changepos`,
    checkIfPositionIsFree: (projectId: number | string, parendDirId: number | string) =>
      `api/projects/${projectId}/numbering/${parendDirId}/checkNewNumber`,
    renumberSubdirectories: (projectId: number | string, parendDirId: number | string) =>
      `api/projects/${projectId}/numbering/${parendDirId}/renumber`,
  },
  OAUTH2: {
    clientAuthenticationRequest: () => `api/oauth2login/auth`,
    clientTokenRequest: () => `api/oauth2login/token`,
    dynamicClientRegistrationRequest: () => `api/oauth2login/reg`,
    getMcpConsent: () => `api/oauth2login/mcp-consent`,
    introspectMcpToken: () => `api/oauth2login/introspect`,
    postMcpConsent: () => `api/oauth2login/mcp-consent`,
  },
  OPENAPI_KEYS: {
    deleteOpenApiKey: (id: number | string) => `api/admin/openapi-keys/${id}`,
    getOpenApiKeysData: () => `api/admin/openapi-keys`,
    postOpenApiKey: () => `api/admin/openapi-keys`,
  },
  ORGANISATIONS: {
    createOrganisation: (projectId: number | string) => `api/projects/${projectId}/organisations`,
    getFilesReport: (projectId: number | string, organisationId: number | string) =>
      `api/projects/${projectId}/organisations/${organisationId}/files.excel`,
    getFiles_1: (projectId: number | string, organisationId: number | string) =>
      `api/projects/${projectId}/organisations/${organisationId}/files`,
    getOrganisation: (projectId: number | string, organisationId: number | string) =>
      `api/projects/${projectId}/organisations/${organisationId}`,
    getOrganisationDetails: (projectId: number | string, organisationId: number | string) =>
      `api/projects/${projectId}/organisations/${organisationId}/details`,
    getOrganisationsOfProject_1: (projectId: number | string) => `api/projects/${projectId}/organisations`,
    updateOrganisation: (projectId: number | string, organisationId: number | string) =>
      `api/projects/${projectId}/organisations/${organisationId}`,
  },
  OX: {
    connect: () => `api/ox/connect`,
    getAccessToken: (projectId: number | string) => `api/projects/${projectId}/ox/token`,
    getOXSettings: () => `api/admin/ox/settings`,
    getOxConfigurationStatus: (projectId: number | string) => `api/projects/${projectId}/ox/status`,
    getStatus_1: () => `api/ox/status`,
    initConnectionByEntryId: (projectId: number | string, entryId: number | string) =>
      `api/projects/${projectId}/ox/init/${entryId}`,
    removeToken: () => `api/ox/token`,
    updateOXServer: () => `api/admin/ox/settings`,
  },
  OXSYNC: {
    downloadSyncFile: (fileGuid: number | string) => `api/ExtApi/${fileGuid}/download`,
    getFilesForSync: (projectId: number | string) => `api/projects/${projectId}/ox/sync-files`,
    getOXSyncToken: () => `api/admin/oxsync/token`,
    getSyncFiles: (projectId: number | string) => `api/ExtApi/${projectId}/onlinebauabnahme`,
    getSyncFiles_1: (projectId: number | string, time: number | string) =>
      `api/ExtApi/${projectId}/onlinebauabnahme/time=${time}`,
    removeFileFromSyncPUT: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/ox/unsync/${fileId}`,
    resolveOXSyncToken: () => `api/admin/oxsync/resolve`,
  },
  PASSWORD: {
    getPasswordPolicyForUserByKey: (resetKey: number | string) => `api/password/${resetKey}/passwordpolicy`,
    requestPasswordReset: () => `api/password/requestreset`,
    requestPasswordResetByAdmin: () => `api/password/admin/requestreset`,
    resetPassword: () => `api/password/resetpassword`,
  },
  PAVE_USERS: {
    applyMailChangeLinkedUser: (tokenText: number | string) => `api/paveusers/verifyMail/${tokenText}`,
    confirmMailAddressLinkedUser: (iduser: number | string) => `api/paveusers/${iduser}/confirmMailAddress`,
    createPAVEUser: () => `api/paveusers/create`,
    deletePAVEUserAuthenticator: (userId: number | string) => `api/paveusers/${userId}/googleauth`,
    getAuthenticatorData: (userId: number | string) => `api/paveusers/${userId}/googleauth`,
    getLinkedPasswordChangeAccess: (userId: number | string) => `api/paveusers/${userId}/password-change-access`,
    getLinkedUserDetails: () => `api/paveusers/userdetails`,
    getLinkedUserLoginModes: () => `api/paveusers/userLoginMode`,
    getLinkedUserSelfSettings: (iduser: number | string) => `api/paveusers/${iduser}/settings`,
    getLinkedUserSettings: (iduser: number | string) => `api/paveusers/${iduser}/settings/full`,
    getLoginTypeLinkedUser: (iduser: number | string) => `api/paveusers/${iduser}/loginsettings`,
    getLoginTypePAVEUser: (iduser: number | string) => `api/paveusers/${iduser}/paveuser/loginsettings`,
    getPAVEUserContactData: (iduser: number | string) => `api/paveusers/${iduser}/paveuser/contact`,
    getPAVEUserSelfSettings: (iduser: number | string) => `api/paveusers/${iduser}/paveuser/settings`,
    getPAVEUserSettings: (iduser: number | string) => `api/paveusers/${iduser}/settings/paveuser/full`,
    getPaveUserJwts: (userId: number | string) => `api/paveusers/${userId}/token`,
    linkUser: () => `api/paveusers/paveuser/link`,
    newsletterLinkedUser: (userId: number | string) => `api/paveusers/${userId}/newsletter`,
    sendPAVEUserMail: () => `api/paveusers/mail`,
    updateLinkedUser: (iduser: number | string) => `api/paveusers/${iduser}`,
    updateLinkedUserPassword: (iduser: number | string) => `api/paveusers/${iduser}/password`,
    updateLinkedUserSettings: (iduser: number | string) => `api/paveusers/${iduser}/settings`,
    updateLinkedUsersContact: (iduser: number | string) => `api/paveusers/${iduser}/contact`,
    updateLoginTypePaveUser: (iduser: number | string) => `api/paveusers/paveuser/${iduser}/secondFactor`,
    updatePAVEUserSettings: (iduser: number | string) => `api/paveusers/${iduser}/paveuser/settings`,
    updatePAVEUsersContact: (iduser: number | string) => `api/paveusers/${iduser}/paveuser/contact`,
    validateMail: () => `api/paveusers/validatemail`,
  },
  PDL: {
    createAndImport: (prid: number | string) => `api/projects/${prid}/pdl`,
    createPDLItems: (prid: number | string, pdlId: number | string, packageId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/packages/${packageId}/items`,
    createPackage: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/packages`,
    deactivatePDL: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/deactivate`,
    deactivatePackage: (prid: number | string, pdlId: number | string, packageId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/packages/${packageId}/deactivate`,
    deletePDLItems: (prid: number | string, pdlId: number | string, packageId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/packages/${packageId}/items`,
    deleteRightsFromPDL: (prid: number | string, pdlId: number | string, pdlAclId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/acl/${pdlAclId}`,
    export: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/excel`,
    exportPackage: (prid: number | string, pdlId: number | string, packageId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/packages/${packageId}/excel`,
    getAllLists: (prid: number | string) => `api/projects/${prid}/pdl`,
    getAllPackages: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/packages`,
    getPDLAssistant: (prid: number | string) => `api/projects/${prid}/pdl/pdlAssistant`,
    getPDLById_1: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}`,
    getPDLById_2: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}`,
    getPdlUserRights: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/userRights`,
    getRightsOfPDL: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/acl`,
    getRightsOfUserOnPDL: (prid: number | string) => `api/projects/${prid}/pdl/acl/currentUser`,
    getSettings_1: (prid: number | string) => `api/projects/${prid}/pdl/settings`,
    importFromExcel: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/import`,
    importPackageFromExcel: (prid: number | string, pdlId: number | string, packageId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/import/${packageId}`,
    reactivatePDL: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/reactivate`,
    readPackage: (prid: number | string, pdlId: number | string, packageId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/packages/${packageId}`,
    searchPDLItemFiles: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/search/${pdlId}`,
    setRightsOnPDL: (prid: number | string, pdlId: number | string) => `api/projects/${prid}/pdl/${pdlId}/acl`,
    updatePDLItem: (
      prid: number | string,
      pdlId: number | string,
      packageId: number | string,
      itemId: number | string
    ) => `api/projects/${prid}/pdl/${pdlId}/packages/${packageId}/items/${itemId}`,
    updatePackage: (prid: number | string, pdlId: number | string, packageId: number | string) =>
      `api/projects/${prid}/pdl/${pdlId}/packages/${packageId}`,
  },
  PDL_SETTINGS: {
    changePDLAdminGroup: (prid: number | string, groupId: number | string) =>
      `api/projects/${prid}/settings/pdl/${groupId}`,
    getPDLById: (prid: number | string) => `api/projects/${prid}/settings/pdl`,
    removePDLAdminGroup: (prid: number | string, groupId: number | string) =>
      `api/projects/${prid}/settings/pdl/${groupId}`,
    setPDLAdminGroup: (prid: number | string, groupId: number | string) =>
      `api/projects/${prid}/settings/pdl/${groupId}`,
  },
  PRINTJOB: {
    createPrintJob: (projectId: number | string) => `api/projects/${projectId}/printjob`,
  },
  PRINTJOB_PROVIDER: {
    getDeliveryNote: (id: number | string, deliveryId: number | string) =>
      `api/printjobs/${id}/delivery_notes/${deliveryId}`,
    getJobAsZip: (id: number | string) => `api/printjobs/${id}/zip`,
    getPdfOverview: (id: number | string) => `api/printjobs/${id}/overview_pdf`,
    getPrintjobDetails: (id: number | string) => `api/printjobs/${id}`,
    getPrintjobFiles: (id: number | string) => `api/printjobs/${id}/file_definitions`,
    getPrintjobProviders: (id: number | string) => `api/printjobs/${id}/providers`,
    getSingleFile: (id: number | string, posId: number | string, filename: number | string) =>
      `api/printjobs/${id}/${posId}/${filename}`,
    setPrintjobDone: (id: number | string) => `api/printjobs/${id}/status`,
  },
  PROJECTGROUPS: {
    createProjectGroup: () => `api/projectgroups`,
    getProjectGroupLogo: (projectGroupId: number | string) => `api/projectgroups/${projectGroupId}/logo`,
    getProjectGroupOfUser: (projectGroupId: number | string) => `api/projectgroups/${projectGroupId}`,
    getProjectGroupsOfUser: () => `api/projectgroups`,
    getUsersOfProjectGroup: (projectGroupId: number | string) => `api/projectgroups/${projectGroupId}/users`,
    updateProjectGroup: (projectGroupId: number | string) => `api/projectgroups/${projectGroupId}`,
  },
  PROJECTS: {
    addMapData: (projectId: number | string) => `api/projects/${projectId}/map`,
    addProjectSummary: (projectId: number | string) => `api/projects/${projectId}/summary`,
    addWebcamData: (projectId: number | string) => `api/projects/${projectId}/webcam`,
    createDelegates: (projectId: number | string) => `api/projects/${projectId}/delegates`,
    deleteBcfServerExtensionEntries: (
      projectId: number | string,
      extension_type: number | string,
      extension_id: number | string
    ) => `api/projects/${projectId}/settings/bcf-server-extensions/${extension_type}/${extension_id}`,
    deleteBcfServerSettings: (projectId: number | string) => `api/projects/${projectId}/settings/bcf-server`,
    deleteDelegate: (
      projectId: number | string,
      iduser: number | string,
      type: number | string,
      delegateId: number | string
    ) => `api/projects/${projectId}/${iduser}/delegate/${type}/${delegateId}`,
    deleteMapData: (projectId: number | string) => `api/projects/${projectId}/map`,
    deleteProjectSummary: (projectId: number | string) => `api/projects/${projectId}/summary`,
    deleteWebcamData: (projectId: number | string) => `api/projects/${projectId}/webcam`,
    getAiChatSettings: (projectId: number | string) => `api/projects/${projectId}/settings/aichat`,
    getBcfServerExtensionEntries: (projectId: number | string) =>
      `api/projects/${projectId}/settings/bcf-server-extensions`,
    getBcfServerSettings: (projectId: number | string) => `api/projects/${projectId}/settings/bcf-server`,
    getDashboardCovers: (projectId: number | string) => `api/projects/${projectId}/cover`,
    getDelegates: (projectId: number | string) => `api/projects/${projectId}/delegates`,
    getFilenameConventionFileData: (projectId: number | string) =>
      `api/projects/${projectId}/settings/filenameConventionFile`,
    getGeneralProjectSettings: (projectId: number | string) => `api/projects/${projectId}/settings/general`,
    getLopGroup: (projectId: number | string) => `api/projects/${projectId}/settings/lop-group`,
    getMailSettings: (projectId: number | string) => `api/projects/${projectId}/settings/mail`,
    getMapData: (projectId: number | string) => `api/projects/${projectId}/map`,
    getMenuInfo: (projectId: number | string) => `api/projects/${projectId}/menu`,
    getPrintJobSettings: (projectId: number | string) => `api/projects/${projectId}/settings/printjob`,
    getProjectLogo: (projectId: number | string) => `api/projects/${projectId}/logo`,
    getProjectMeetingsGroup: (projectId: number | string) => `api/projects/${projectId}/settings/meetings-group`,
    getProjectSummary_1: (projectId: number | string) => `api/projects/${projectId}/summary`,
    getProjectWebcam_1: (projectId: number | string) => `api/projects/${projectId}/webcam`,
    getProject_1: (projectId: number | string) => `api/projects/${projectId}`,
    getProjectsOfUser: () => `api/projects`,
    getUsersByProjectId_1: (projectId: number | string) => `api/projects/${projectId}/users`,
    getZipFileProjectSettings: (projectId: number | string) => `api/projects/${projectId}/settings/zipfiles`,
    postBcfServerExtensionEntries: (projectId: number | string, extension_type: number | string) =>
      `api/projects/${projectId}/settings/bcf-server-extensions/${extension_type}`,
    putBcfServerExtensionEntries: (
      projectId: number | string,
      extension_type: number | string,
      extension_id: number | string
    ) => `api/projects/${projectId}/settings/bcf-server-extensions/${extension_type}/${extension_id}`,
    removeProjectCoverImage: (projectId: number | string) => `api/projects/${projectId}/cover/image`,
    removeProjectLogoImage: (projectId: number | string) => `api/projects/${projectId}/logo/image`,
    setAiChatSettings: (projectId: number | string) => `api/projects/${projectId}/settings/aichat`,
    setBcfServerSettings: (projectId: number | string) => `api/projects/${projectId}/settings/bcf-server`,
    setGeneralProjectSettings: (projectId: number | string) => `api/projects/${projectId}/settings/general`,
    setLopGroup: (projectId: number | string) => `api/projects/${projectId}/settings/lop-group`,
    setMailSettings: (projectId: number | string) => `api/projects/${projectId}/settings/mail`,
    setPrintJobSettings: (projectId: number | string) => `api/projects/${projectId}/settings/printjob`,
    setProjectMeetingsGroup: (projectId: number | string) => `api/projects/${projectId}/settings/meetings-group`,
    setZipFileSettings: (projectId: number | string) => `api/projects/${projectId}/settings/zipfiles`,
    storeFilenameConventionFileData: (projectId: number | string) =>
      `api/projects/${projectId}/settings/filenameConventionFile`,
    storeProjectCoverImage: (projectId: number | string) => `api/projects/${projectId}/cover/image`,
    storeProjectLogoImage: (projectId: number | string) => `api/projects/${projectId}/logo/image`,
    storeProjectLogoText: (projectId: number | string) => `api/projects/${projectId}/logo/text`,
    updateMapData: (projectId: number | string) => `api/projects/${projectId}/map`,
    updateProjectSummary: (projectId: number | string) => `api/projects/${projectId}/summary`,
    updateWebcamData: (projectId: number | string) => `api/projects/${projectId}/webcam`,
    verifySecureCloudAccess: (projectId: number | string) => `api/projects/${projectId}/verify`,
  },
  PROJECT_GROUP_ADMIN: {
    getAllServer: () => `api/admin/oauth2/servers`,
  },
  PROJECT_INBOXES: {
    createMailFilter: (projectId: number | string) => `api/projects/${projectId}/mails/project-inbox/management/filter`,
    createMailInbox: (projectId: number | string) => `api/projects/${projectId}/mails/project-inbox/management`,
    createMailRule: (projectId: number | string) => `api/projects/${projectId}/mails/project-inbox/management/rule`,
    deleteMailFilter: (projectId: number | string, filterId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/filter/${filterId}`,
    deleteMailInbox: (projectId: number | string, inboxId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/${inboxId}`,
    deleteMailRule: (projectId: number | string, ruleId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/rule/${ruleId}`,
    getFilenameConventionsForInboxes: (projectId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/filter/conventions`,
    getMailFilter: (projectId: number | string, filterId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/filter/${filterId}`,
    getMailFilters: (projectId: number | string) => `api/projects/${projectId}/mails/project-inbox/management/filter`,
    getMailInbox: (projectId: number | string, inboxId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/${inboxId}`,
    getMailInboxes: (projectId: number | string) => `api/projects/${projectId}/mails/project-inbox/management`,
    getMailRule: (projectId: number | string, ruleId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/rule/${ruleId}`,
    getMailRules: (projectId: number | string) => `api/projects/${projectId}/mails/project-inbox/management/rule`,
    getProjectInboxContent: (projectId: number | string, inboxId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/${inboxId}`,
    getProjectInboxList: (projectId: number | string) => `api/projects/${projectId}/mails/project-inbox`,
    updateMailFilter: (projectId: number | string, filterId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/filter/${filterId}`,
    updateMailInbox: (projectId: number | string, inboxId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/${inboxId}`,
    updateMailRule: (projectId: number | string, ruleId: number | string) =>
      `api/projects/${projectId}/mails/project-inbox/management/rule/${ruleId}`,
  },
  PROVIDER: {
    assignReproService: (projectId: number | string, providerId: number | string) =>
      `api/projects/${projectId}/providers/${providerId}/assign`,
    getProjectProviders: (projectId: number | string) => `api/projects/${projectId}/providers`,
    getProviderById: (projectId: number | string, providerId: number | string) =>
      `api/projects/${projectId}/providers/${providerId}`,
    unassignReproService: (projectId: number | string, assignmentId: number | string) =>
      `api/projects/${projectId}/providers/${assignmentId}/unassign`,
    updateReproService: (projectId: number | string, providerId: number | string) =>
      `api/projects/${projectId}/providers/${providerId}`,
  },
  QA: {
    admit: (projectId: number | string, id: number | string) => `api/projects/${projectId}/qa/questions/${id}/admit`,
    answerAddComment: (projectId: number | string, answerId: number | string) =>
      `api/projects/${projectId}/qa/answers/${answerId}/comments`,
    answerDeleteComment: (projectId: number | string, answerId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/qa/answers/${answerId}/comments/${commentId}`,
    answerUpdateComment: (projectId: number | string, answerId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/qa/answers/${answerId}/comments/${commentId}`,
    approveAnswer: (projectId: number | string, answerId: number | string) =>
      `api/projects/${projectId}/qa/answers/${answerId}/approve`,
    buyerGatekeeperReject: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/buyerGatekeeperReject`,
    categoryApprovalReject: (projectId: number | string, answerId: number | string) =>
      `api/projects/${projectId}/qa/answers/${answerId}/decline`,
    changeCategory: (projectId: number | string, questionId: number | string, categoryId: number | string) =>
      `api/projects/${projectId}/qa/questions/${questionId}/category/${categoryId}`,
    createNewAnswer: (projectId: number | string, questionId: number | string) =>
      `api/projects/${projectId}/qa/questions/${questionId}/answers`,
    createNewCategory: (projectId: number | string) => `api/projects/${projectId}/qa/categories`,
    createNewQuestion: (projectId: number | string) => `api/projects/${projectId}/qa/questions`,
    delegate: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/delegate`,
    edit: (projectId: number | string, id: number | string) => `api/projects/${projectId}/qa/questions/${id}/edit`,
    forwardToSpecialist: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/forwardToSpecialist`,
    getAnswers: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/answers`,
    getCategories_1: (projectId: number | string) => `api/projects/${projectId}/qa/categories`,
    getCategory: (projectId: number | string, id: number | string) => `api/projects/${projectId}/qa/categories/${id}`,
    getMentionedUsers: (projectId: number | string) => `api/projects/${projectId}/qa/mentioned-users`,
    getQuestion: (projectId: number | string, id: number | string) => `api/projects/${projectId}/qa/questions/${id}`,
    getQuestionCounts: (projectId: number | string) => `api/projects/${projectId}/qa/questions/counts`,
    getQuestionLimit: (projectId: number | string) => `api/projects/${projectId}/qa/questions/limits`,
    getQuestions: (projectId: number | string) => `api/projects/${projectId}/qa/questions`,
    getQuestionsReport: (projectId: number | string) => `api/projects/${projectId}/qa/questions/excel`,
    getQuestionsSearchReport: (projectId: number | string) => `api/projects/${projectId}/qa/questions/search/excel`,
    getSettings_2: (projectId: number | string) => `api/projects/${projectId}/qa/settings`,
    publish: (projectId: number | string, id: number | string) => `api/projects/${projectId}/qa/questions/${id}/type`,
    questionAddComment: (projectId: number | string, questionId: number | string) =>
      `api/projects/${projectId}/qa/questions/${questionId}/comments`,
    questionDeleteComment: (projectId: number | string, questionId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/qa/questions/${questionId}/comments/${commentId}`,
    questionGetComments: (projectId: number | string, answerId: number | string) =>
      `api/projects/${projectId}/qa/answers/${answerId}/comments`,
    questionGetComments_1: (projectId: number | string, questionId: number | string) =>
      `api/projects/${projectId}/qa/questions/${questionId}/comments`,
    questionUpdateComment: (projectId: number | string, questionId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/qa/questions/${questionId}/comments/${commentId}`,
    searchQuestions: (projectId: number | string) => `api/projects/${projectId}/qa/questions/search`,
    sellerGatekeeperReject: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/sellerGatekeeperReject`,
    specialistReject: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/specialistReject`,
    startWork: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/startWork`,
    submit: (projectId: number | string, id: number | string) => `api/projects/${projectId}/qa/questions/${id}/submit`,
    updateAnswer: (projectId: number | string, id: number | string) => `api/projects/${projectId}/qa/answers/${id}`,
    updateCategory_1: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/categories/${id}`,
    updateSettings_1: (projectId: number | string) => `api/projects/${projectId}/qa/settings`,
    withdraw: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/qa/questions/${id}/withdraw`,
  },
  RELEASE_NOTES: {
    getReleaseNotes: () => `api/admin/release-notes`,
    getReleaseNotes_1: () => `api/release-notes`,
  },
  REPORTS: {
    getAccessRightsAsFile: (projectId: number | string) => `api/projects/${projectId}/reports/accessrights.excel`,
    getAccessRightsInfo: (projectId: number | string) => `api/projects/${projectId}/reports/accessrightsinfo`,
    getActivitiesAsFile: (projectId: number | string) => `api/projects/${projectId}/reports/activities/project.excel`,
    getActivityTypes: (projectId: number | string) => `api/projects/${projectId}/reports/activities/logtypes`,
    getAllFiles: (projectId: number | string) => `api/projects/${projectId}/reports/documents`,
    getAllFilesAsExcel: (projectId: number | string) => `api/projects/${projectId}/reports/documents.excel`,
    getAllFilesAsPdf: (projectId: number | string) => `api/projects/${projectId}/reports/documents.pdf`,
    getDocumentActivitiesByOrg: (projectId: number | string) =>
      `api/projects/${projectId}/reports/activities/documents/organisations`,
    getDocumentsActivities: (projectId: number | string) => `api/projects/${projectId}/reports/activities/documents`,
    getOrganisationsActivities: (projectId: number | string) =>
      `api/projects/${projectId}/reports/activities/organisations`,
    getOrganisationsActivitiesList: (projectId: number | string) =>
      `api/projects/${projectId}/reports/activities/organisations/list`,
    getPrintJobAsPdf: (projectId: number | string, printjobId: number | string) =>
      `api/projects/${projectId}/reports/printjobs/${printjobId}/printjob.pdf`,
    getPrintJobsAsExcel: (projectId: number | string) => `api/projects/${projectId}/reports/printjobs.excel`,
    getPrintJobsAsPdf: (projectId: number | string) => `api/projects/${projectId}/reports/printjobs.pdf`,
    getPrintjobDetails_1: (projectId: number | string, printjobId: number | string) =>
      `api/projects/${projectId}/reports/printjobs/${printjobId}`,
    getPrintjobs: (projectId: number | string) => `api/projects/${projectId}/reports/printjobs`,
    getProjectActivities: (projectId: number | string) => `api/projects/${projectId}/reports/activities/project`,
    getQAActivities: (projectId: number | string) => `api/projects/${projectId}/reports/activities/qa`,
    getQAActivitiesByTime: (projectId: number | string) => `api/projects/${projectId}/reports/activities/qa/time`,
    getReportSettings: (projectId: number | string) => `api/projects/${projectId}/settings/reports`,
    getUserStatus: (projectId: number | string) => `api/projects/${projectId}/reports/userstatus`,
    getUsersActivities: (projectId: number | string) => `api/projects/${projectId}/reports/activities/users`,
    getUsersActivitiesList: (projectId: number | string) => `api/projects/${projectId}/reports/activities/users/list`,
    getUsersFromProjectLogs: (projectId: number | string) => `api/projects/${projectId}/reports/activities/loggedusers`,
    updateSettings: (projectId: number | string) => `api/projects/${projectId}/settings/reports`,
  },
  RESOLUTIONS: {
    getResolutionsList: (projectId: number | string) => `api/projects/${projectId}/resolutions`,
  },
  SEARCH: {
    deleteQuery: (projectId: number | string, id: number | string) => `api/projects/${projectId}/search/queries/${id}`,
    editSearchQuery: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/search/queries/${id}`,
    executeQuery: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/search/queries/${id}/execute`,
    getAllStatusOfFilesInProject: (projectId: number | string) => `api/projects/${projectId}/search/documents/status`,
    getSearchQueries: (projectId: number | string) => `api/projects/${projectId}/search/queries`,
    getSearchQueryById: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/search/queries/${id}`,
    getSearchResults: (projectId: number | string) => `api/projects/${projectId}/search/documents`,
    storeSearchQuery: (projectId: number | string) => `api/projects/${projectId}/search/queries`,
  },
  STA: {
    getConfigureUrl: (projectId: number | string) => `api/projects/${projectId}/sta/configure-url`,
    getLoginUrl: (projectId: number | string) => `api/projects/${projectId}/sta/login-url`,
    getUserLinkStatus: (projectId: number | string) => `api/projects/${projectId}/sta/link`,
    saveUserLink: (projectId: number | string) => `api/projects/${projectId}/sta/link`,
  },
  TAGS: {
    getDownloadWizardRequest: (projectId: number | string) => `api/projects/${projectId}/files/downloadWizard/init`,
  },
  TASKS: {
    acceptTask: (projectId: number | string, taskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/accept`,
    addComment_1: (projectId: number | string, taskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/comments`,
    createSubtask: (projectId: number | string, taskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/subtasks`,
    createTask: (projectId: number | string) => `api/projects/${projectId}/tasks`,
    createTasklist: (projectId: number | string) => `api/projects/${projectId}/tasks/lists`,
    declineTask: (projectId: number | string, taskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/decline`,
    deleteComment_1: (projectId: number | string, taskId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/comments/${commentId}`,
    deleteSubTask: (projectId: number | string, taskId: number | string, subtaskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/subtasks/${subtaskId}`,
    deleteTask: (projectId: number | string, taskId: number | string) => `api/projects/${projectId}/tasks/${taskId}`,
    deleteTasklist: (projectId: number | string, listId: number | string) =>
      `api/projects/${projectId}/tasks/lists/${listId}`,
    getComments_1: (projectId: number | string, taskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/comments`,
    getGlobalTasksInList: (projectId: number | string, listId: number | string) =>
      `api/projects/${projectId}/tasks/global/${listId}`,
    getPrivateTasksInList: (projectId: number | string, listId: number | string) =>
      `api/projects/${projectId}/tasks/private/${listId}`,
    getSubtasks: (projectId: number | string, taskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/subtasks`,
    getTask: (projectId: number | string, taskId: number | string) => `api/projects/${projectId}/tasks/${taskId}`,
    getTasklists: (projectId: number | string) => `api/projects/${projectId}/tasks/lists`,
    updateComment: (projectId: number | string, taskId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/comments/${commentId}`,
    updateSubtask: (projectId: number | string, taskId: number | string, subtaskId: number | string) =>
      `api/projects/${projectId}/tasks/${taskId}/subtasks/${subtaskId}`,
    updateTask: (projectId: number | string, taskId: number | string) => `api/projects/${projectId}/tasks/${taskId}`,
    updateTasklist: (projectId: number | string, listId: number | string) =>
      `api/projects/${projectId}/tasks/lists/${listId}`,
  },
  TEAMS_FEEDBACK: {
    sendFeedback: () => `api/teams-integration/feedback`,
  },
  TEMPLATES: {
    getAllTemplates_1: (projectId: number | string) => `api/projects/${projectId}/templates`,
  },
  TENDER: {
    abortCall: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/abort`,
    changeNotifications: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/notifications`,
    changeParticipants: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/participants`,
    createBidder: (projectId: number | string) => `api/projects/${projectId}/tender/bidders`,
    createCall: (projectId: number | string) => `api/projects/${projectId}/tender/calls`,
    createSignature: (projectId: number | string) => `api/projects/${projectId}/tender/templates/signatures`,
    createTemplate_1: (projectId: number | string) => `api/projects/${projectId}/tender/templates`,
    createTrade: (projectId: number | string) => `api/projects/${projectId}/tender/trades`,
    deleteBidder: (projectId: number | string, id: number | string) => `api/projects/${projectId}/tender/bidders/${id}`,
    deleteTemplate: (projectId: number | string, templateId: number | string) =>
      `api/projects/${projectId}/tender/templates/${templateId}`,
    deleteTrade: (projectId: number | string, id: number | string) => `api/projects/${projectId}/tender/trades/${id}`,
    endInspection: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/endInspection`,
    endReview: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/endReview`,
    getAllBidders: (projectId: number | string) => `api/projects/${projectId}/tender/bidders`,
    getAllBiddersAsExcel: (projectId: number | string) => `api/projects/${projectId}/tender/bidders/export`,
    getAllCalls: (projectId: number | string) => `api/projects/${projectId}/tender/calls`,
    getAllPools: (projectId: number | string) => `api/projects/${projectId}/tender/pool`,
    getAllTemplatesByPurpose: (projectId: number | string) => `api/projects/${projectId}/tender/templates`,
    getAllTrades: (projectId: number | string) => `api/projects/${projectId}/tender/trades`,
    getAllTradesAsExcel: (projectId: number | string) => `api/projects/${projectId}/tender/trades/export`,
    getAllUsersPerGroup: (projectId: number | string) => `api/projects/${projectId}/tender/pool/users`,
    getBidderById: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/tender/bidders/${id}`,
    getBidderById_1: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/tender/bidders/${id}`,
    getBidderParticipants: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/participants/bidders`,
    getCallDetails: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/general`,
    getFileDownload: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/download`,
    getNotifications: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/notifications`,
    getOffers: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/offers`,
    getParticipants: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/participants/users`,
    getPool: (projectId: number | string, role: number | string) => `api/projects/${projectId}/tender/pool/${role}`,
    getSettings_3: (projectId: number | string) => `api/projects/${projectId}/tender/templates/settings`,
    getSignature: (projectId: number | string, signatureId: number | string) =>
      `api/projects/${projectId}/tender/templates/signatures/${signatureId}`,
    getSignatures: (projectId: number | string) => `api/projects/${projectId}/tender/templates/signatures`,
    getTemplateDetails: (projectId: number | string, templateId: number | string) =>
      `api/projects/${projectId}/tender/templates/${templateId}`,
    getTimeFilter: (projectId: number | string) => `api/projects/${projectId}/tender/calls/timefilter`,
    getTradeById: (projectId: number | string, id: number | string) => `api/projects/${projectId}/tender/trades/${id}`,
    importBidders: (projectId: number | string) => `api/projects/${projectId}/tender/bidders/import`,
    importTrades: (projectId: number | string) => `api/projects/${projectId}/tender/trades/import`,
    makeProjectDefault: (projectId: number | string, templateId: number | string) =>
      `api/projects/${projectId}/tender/templates/${templateId}/default`,
    negativeReply: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/participants/negativeReply`,
    reInvite: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/participants/reInvite`,
    reactivateBidder: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/tender/bidders/${id}/activate`,
    reactivateTrade: (projectId: number | string, id: number | string) =>
      `api/projects/${projectId}/tender/trades/${id}/activate`,
    resetAccessData: (projectId: number | string, callId: number | string, bidderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/participants/${bidderId}/reset`,
    restoreTemplate: (projectId: number | string, templateId: number | string) =>
      `api/projects/${projectId}/tender/templates/${templateId}/restore`,
    startCall: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/start`,
    unlockAccess: (projectId: number | string, callId: number | string, bidderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/participants/${bidderId}/unlock`,
    updateCallDetails: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/general`,
    updatePool: (projectId: number | string, role: number | string) => `api/projects/${projectId}/tender/pool/${role}`,
    updatePools: (projectId: number | string) => `api/projects/${projectId}/tender/pool`,
    updateSenderOption: (projectId: number | string) => `api/projects/${projectId}/tender/templates/senderSetting`,
    updateSignature: (projectId: number | string, signatureId: number | string) =>
      `api/projects/${projectId}/tender/templates/signatures/${signatureId}`,
    updateSignatureOption: (projectId: number | string) =>
      `api/projects/${projectId}/tender/templates/signatureSetting`,
    updateTemplate_1: (projectId: number | string, templateId: number | string) =>
      `api/projects/${projectId}/tender/templates/${templateId}`,
    updateTimeFilter: (projectId: number | string) => `api/projects/${projectId}/tender/calls/timefilter`,
    updateTrade: (projectId: number | string, id: number | string) => `api/projects/${projectId}/tender/trades/${id}`,
  },
  TENDERVIEWER: {
    addComment_2: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/easyviewer/comments`,
    deleteComment_2: (
      projectId: number | string,
      callId: number | string,
      fileId: number | string,
      commentId: number | string
    ) => `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/easyviewer/comments/${commentId}`,
    editComment_1: (
      projectId: number | string,
      callId: number | string,
      fileId: number | string,
      commentId: number | string
    ) => `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/easyviewer/comments/${commentId}`,
    getEasyViewerComments: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/easyviewer/comments`,
    getEasyViewerFileSize_2: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/easyviewer`,
    getEasyViewerFile_3: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/easyviewer`,
    getTenderWebViewerFile: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/webviewer`,
  },
  TENDER_DOCUMENT: {
    uploadFileToTemp: (projectId: number | string, callId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}/upload/temp`,
  },
  TENDER_DOCUMENTS: {
    addLocalFile: (projectId: number | string, callId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}/upload/local`,
    addProjectFile: (projectId: number | string, callId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}/upload/file`,
    addProjectFolder: (
      projectId: number | string,
      callId: number | string,
      folderId: number | string,
      id: number | string
    ) => `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}/upload/folder/${id}`,
    createTenderFolder: (projectId: number | string, callId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}/folder`,
    deleteFilesAsBidder: (callId: number | string) => `api/tender/${callId}/documents`,
    deleteFiles_2: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents`,
    getTenderFolder: (projectId: number | string, callId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}`,
    getTenderRoot: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents`,
    move_1: (projectId: number | string, callId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/move`,
    readFoldersArea: (projectId: number | string, callId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}/rootdirs`,
    submitUpload: (projectId: number | string, callId: number | string, folderId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${folderId}/upload/submit`,
  },
  TENDER_GUEST: {
    getCallDataForBidder: (callId: number | string) => `api/tender/${callId}/details`,
    getDocuments: (callId: number | string) => `api/tender/${callId}/documents/call`,
    getDocumentsByFolder: (callId: number | string, folderId: number | string) =>
      `api/tender/${callId}/documents/call/${folderId}`,
    getFileDownload_1: (callId: number | string) => `api/tender/${callId}/documents/download`,
    getOwnDocuments: (callId: number | string) => `api/tender/${callId}/documents/bidder`,
    uploadFile: (callId: number | string) => `api/tender/${callId}/documents/bidder`,
  },
  TENDER_GUEST_OWN: {
    getBidderData: (callId: number | string) => `api/tender/${callId}/bidderData`,
  },
  TENDER_GUEST_STATUS: {
    acceptInvite: (callId: number | string) => `api/tender/${callId}/acceptInvite`,
    denyInvitation: (callId: number | string) => `api/tender/${callId}/deny`,
    getBidderStatus: (callId: number | string) => `api/tender/${callId}/bidderStatus`,
  },
  THIRD_PARTY_ADMIN: {
    addExternalApp: () => `api/apps/v1/admin/applications`,
    generateClientInformation: () => `api/apps/v1/admin/generateclientinfos`,
    getAllExternalApps: () => `api/apps/v1/admin/applications`,
    getExternalApplicationById: (appId: number | string) => `api/apps/v1/admin/applications/${appId}`,
    updateExternalApp: (appId: number | string) => `api/apps/v1/admin/applications/${appId}`,
  },
  THIRD_PARTY_API: {
    checkFileLatestVersion: (projectId: number | string, fileId: number | string) =>
      `api/apps/v1/project/${projectId}/file/${fileId}/latestversion`,
    checkUploadedFilesThirdParty: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/fileUpload/${folderId}/check`,
    deleteFiles: (projectId: number | string) => `api/apps/v1/project/${projectId}/files/deleteFiles`,
    deleteFolder: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/folder/${folderId}`,
    getFileContent: (projectId: number | string, fileId: number | string) =>
      `api/apps/v1/project/${projectId}/file/${fileId}`,
    getFileContentUnique: (projectId: number | string, fileId: number | string, uniqueId: number | string) =>
      `api/apps/v1/project/${projectId}/file/${fileId}/unique/${uniqueId}`,
    getFileDetails: (projectId: number | string, fileId: number | string) =>
      `api/apps/v1/project/${projectId}/file/${fileId}/info`,
    getFileMetadata: (projectId: number | string, fileId: number | string) =>
      `api/apps/v1/project/${projectId}/file/${fileId}/metadata`,
    getFileShareLink: (projectId: number | string, fileId: number | string) =>
      `api/apps/v1/project/${projectId}/file/${fileId}/share`,
    getFolder: (projectId: number | string) => `api/apps/v1/project/${projectId}/folder`,
    getFolderWithId: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/folder/${folderId}`,
    getProjectGroups: (projectId: number | string) => `api/apps/v1/project/${projectId}/groups`,
    getProjectInfo: (projectId: number | string) => `api/apps/v1/project/${projectId}`,
    getProjectMap: (projectId: number | string) => `api/apps/v1/project/${projectId}/map`,
    getProjectSummary: (projectId: number | string) => `api/apps/v1/project/${projectId}/summary`,
    getProjectWebcam: (projectId: number | string) => `api/apps/v1/project/${projectId}/webcam`,
    getProjects: () => `api/apps/v1/project`,
    getRefreshedFiles: (projectId: number | string) => `api/apps/v1/project/${projectId}/file/refresh`,
    getSpecificGroupMembers: (projectId: number | string, groupId: number | string) =>
      `api/apps/v1/project/${projectId}/groups/${groupId}/members`,
    getToken: () => `api/apps/v1/login/token`,
    getUsersByProjectId: (projectId: number | string) => `api/apps/v1/project/${projectId}/users`,
    getVersionsInfo: (projectId: number | string, fileId: number | string) =>
      `api/apps/v1/project/${projectId}/file/${fileId}/versions`,
    loginUserAndGetToken: () => `api/apps/v1/login`,
    moveFiles: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/files/parent/${folderId}`,
    moveFolder: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/folder/${folderId}/parent`,
    persistFilesThirdParty: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/fileUpload/${folderId}/persist`,
    prepareTempFilesThirdParty: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/fileUpload/${folderId}/temp`,
    renameAndRestoreFolder: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/folder/${folderId}`,
    restoreFile: (projectId: number | string) => `api/apps/v1/project/${projectId}/files/restore`,
    searchFileInFolderWithId: (projectId: number | string) => `api/apps/v1/project/${projectId}/file/search`,
    searchFileInFolderWithId_1: (
      projectId: number | string,
      workflownumber: number | string,
      stepName: number | string
    ) => `api/apps/v1/project/${projectId}/workflow/${workflownumber}/commit/${stepName}`,
    thirdPartyBcfServerAddProjectFile: (projectId: number | string, topicGuid: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/${topicGuid}/attachments`,
    thirdPartyBcfServerAddProjectFile_1: (
      projectId: number | string,
      topicGuid: number | string,
      fileId: number | string
    ) => `api/apps/v1/projects/${projectId}/bcf-ext/${topicGuid}/${fileId}`,
    thirdPartyBcfServerDeleteComment: (
      project_id: number | string,
      topic_id: number | string,
      comment_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}`,
    thirdPartyBcfServerDeleteViewpoint: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}`,
    thirdPartyBcfServerGetAllTopicsWithIfcProjects: (projectId: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/topics_with_ifc`,
    thirdPartyBcfServerGetAttachments: (projectId: number | string, topicGuid: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/${topicGuid}/attachments`,
    thirdPartyBcfServerGetCommentById: (
      project_id: number | string,
      topic_id: number | string,
      comment_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}`,
    thirdPartyBcfServerGetCommentEvents: (project_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/comments/events`,
    thirdPartyBcfServerGetCommentEventsByCommentId: (
      project_id: number | string,
      topic_id: number | string,
      comment_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}/events`,
    thirdPartyBcfServerGetComments: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments`,
    thirdPartyBcfServerGetDocumentByGuid: (project_id: number | string, document_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/documents/${document_id}`,
    thirdPartyBcfServerGetDocumentReferences: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/document_references`,
    thirdPartyBcfServerGetDocuments: (project_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/documents`,
    thirdPartyBcfServerGetFileInformation: (project_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/files_information`,
    thirdPartyBcfServerGetProjectExtensions: (project_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/extensions`,
    thirdPartyBcfServerGetProjects: () => `api/apps/v1/bcf/3.0/projects`,
    thirdPartyBcfServerGetTopicById: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}`,
    thirdPartyBcfServerGetTopicEvents: (project_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/events`,
    thirdPartyBcfServerGetTopicEventsByTopicId: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/events`,
    thirdPartyBcfServerGetTopicFileInfo: (projectId: number | string, topicGuid: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/${topicGuid}/files`,
    thirdPartyBcfServerGetTopicFiles: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/files`,
    thirdPartyBcfServerGetTopics: (project_id: number | string) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics`,
    thirdPartyBcfServerGetTopicsWithThumbnails: (projectId: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/topics_with_thumbnails`,
    thirdPartyBcfServerGetTopicsWithThumbnails_1: (projectId: number | string, topicGuid: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/thumbnail/${topicGuid}`,
    thirdPartyBcfServerGetViewpointBitmap: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string,
      bitmap_id: number | string
    ) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/bitmaps/${bitmap_id}`,
    thirdPartyBcfServerGetViewpointById: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}`,
    thirdPartyBcfServerGetViewpointColoring: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/coloring`,
    thirdPartyBcfServerGetViewpointSelection: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/selection`,
    thirdPartyBcfServerGetViewpointSnapshot: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/snapshot`,
    thirdPartyBcfServerGetViewpointVisibility: (
      project_id: number | string,
      topic_id: number | string,
      viewpoint_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints/${viewpoint_id}/visibility`,
    thirdPartyBcfServerGetViewpoints: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints`,
    thirdPartyBcfServerPostComments: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments`,
    thirdPartyBcfServerPostDocument: (project_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/documents`,
    thirdPartyBcfServerPostDocumentReference: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/document_references`,
    thirdPartyBcfServerPostTopic: (project_id: number | string) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics`,
    thirdPartyBcfServerPostViewpoint: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/viewpoints`,
    thirdPartyBcfServerPutComment: (
      project_id: number | string,
      topic_id: number | string,
      comment_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/comments/${comment_id}`,
    thirdPartyBcfServerPutDocumentReference: (
      project_id: number | string,
      topic_id: number | string,
      document_reference_id: number | string
    ) => `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/document_references/${document_reference_id}`,
    thirdPartyBcfServerPutTopicById: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}`,
    thirdPartyBcfServerPutTopicFiles: (project_id: number | string, topic_id: number | string) =>
      `api/apps/v1/bcf/3.0/projects/${project_id}/topics/${topic_id}/files`,
    thirdPartyBcfServerRemoveAttachments: (projectId: number | string, topicGuid: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/${topicGuid}/attachments`,
    thirdPartyBcfServerRemoveProjectFile: (projectId: number | string, topicGuid: number | string) =>
      `api/apps/v1/projects/${projectId}/bcf-ext/${topicGuid}/deleteFile`,
    thirdPartyCreateFolders: (projectId: number | string) => `api/apps/v1/project/${projectId}/folder`,
    thirdPartyDocumentApiSaveUsersSelection: () => `api/apps/v1/opencde/documents/v1/document-selection`,
    thirdPartyDocumentsApiCancelUpload: () => `api/apps/v1/opencde/documents/v1/cancel-upload`,
    thirdPartyDocumentsApiCompleteUpload: () => `api/apps/v1/opencde/documents/v1/upload-completion`,
    thirdPartyDocumentsApiDownloadDocument: (documentGuid: number | string) =>
      `api/apps/v1/opencde/documents/v1/${documentGuid}/download`,
    thirdPartyDocumentsApiEnterMetadata: () => `api/apps/v1/opencde/documents/v1/document-metadata`,
    thirdPartyDocumentsApiGetDocumentMetadata: (documentGuid: number | string) =>
      `api/apps/v1/opencde/documents/v1/${documentGuid}/metadata`,
    thirdPartyDocumentsApiGetDocumentVersion: (documentGuid: number | string) =>
      `api/apps/v1/opencde/documents/v1/${documentGuid}/version`,
    thirdPartyDocumentsApiGetDocumentVersions: (documentGuid: number | string) =>
      `api/apps/v1/opencde/documents/v1/${documentGuid}/versions`,
    thirdPartyDocumentsApiGetUploadInstructions: () => `api/apps/v1/opencde/documents/v1/upload-instructions`,
    thirdPartyDocumentsApiGetUsersSelection: () => `api/apps/v1/opencde/documents/v1/download-instructions`,
    thirdPartyDocumentsApiInitiateDownload: () => `api/apps/v1/opencde/documents/v1/select-documents`,
    thirdPartyDocumentsApiInitiateDownload_1: () => `api/apps/v1/opencde/documents/v1/upload-documents`,
    thirdPartyDocumentsApiUploadFile: (session_file_id: number | string) =>
      `api/apps/v1/opencde/documents/v1/upload-chunk/${session_file_id}`,
    thirdPartyGetAuthInformation: () => `api/apps/v1/foundation/1.0/auth`,
    thirdPartyGetBcfAuthInformation: () => `api/apps/v1/bcf/2.1/auth`,
    thirdPartyGetCurrentUser: () => `api/apps/v1/foundation/1.0/current-user`,
    thirdPartyGetFoundationVersions: () => `api/apps/v1/foundation/versions`,
    uploadFileToFolder: (projectId: number | string, folderId: number | string) =>
      `api/apps/v1/project/${projectId}/fileUpload/${folderId}`,
    uploadFileToWorkflow: (projectId: number | string, workflownumber: number | string) =>
      `api/apps/v1/project/${projectId}/workflow/${workflownumber}/fileUpload`,
  },
  UNDEFINED: {
    checkFileInfo: (fileId: number | string) => `api/wopi/files/${fileId}`,
    dbCheck: () => `api/ExtApi/@/statuscheck`,
    getExternalGrammar: (path: number | string) => `api/application.wadl/${path}`,
    getFileContents: (fileId: number | string) => `api/wopi/files/${fileId}/contents`,
    getWadl: () => `api/application.wadl`,
    lock: (fileId: number | string) => `api/wopi/files/${fileId}`,
    updateFileContents: (fileId: number | string) => `api/wopi/files/${fileId}/contents`,
  },
  UPLOAD: {
    abortChunkUpload: (projectId: number | string, uploadId: number | string) =>
      `api/projects/${projectId}/upload-chunks/${uploadId}/cancel`,
    addFileChunk: (projectId: number | string, uploadId: number | string) =>
      `api/projects/${projectId}/upload-chunks/${uploadId}`,
    finishChunkUpload: (projectId: number | string, uploadId: number | string) =>
      `api/projects/${projectId}/upload-chunks/${uploadId}/finish`,
    getTriggerSize: (projectId: number | string) => `api/projects/${projectId}/upload-chunks/triggerSize`,
    initChunkUpload: (projectId: number | string) => `api/projects/${projectId}/upload-chunks/init`,
  },
  USERS: {
    applyMailChange: (tokenText: number | string) => `api/users/verifyMail/${tokenText}`,
    checkUserId: () => `api/users/userid/check`,
    confirmMailAddress: (iduser: number | string) => `api/users/${iduser}/confirmMailAddress`,
    createListOfUsers: () => `api/users/list`,
    createUser: () => `api/users`,
    deleteUser: (iduser: number | string) => `api/users/${iduser}`,
    generateValidUserId: () => `api/users/userid/generate`,
    getAccountById: (accountId: number | string) => `api/users/paveusers/${accountId}`,
    getAllPAVEUsers: () => `api/users/paveusers`,
    getContactCard_1: (projectId: number | string, userId: number | string) =>
      `api/projects/${projectId}/users/${userId}/vcard`,
    getLinkedUserDetailsAdmin: (idAccount: number | string) => `api/users/profiledetails/${idAccount}`,
    getLoginType: (iduser: number | string) => `api/users/${iduser}/loginsettings`,
    getPasswordChangeAccess: (userId: number | string) => `api/users/${userId}/password-change-access`,
    getUser: (iduser: number | string) => `api/users/${iduser}`,
    getUserContactData: (iduser: number | string) => `api/users/${iduser}/contact`,
    getUserLoginModes: () => `api/users/userLoginMode`,
    getUserSelfSettings: (iduser: number | string) => `api/users/${iduser}/settings`,
    getUserSettings: (iduser: number | string) => `api/users/${iduser}/settings/full`,
    getUserTecInfo: (iduser: number | string) => `api/users/${iduser}/info`,
    getUsers: () => `api/users`,
    getUsersForPrintJobs: (id: number | string) => `api/admin/printjobprovider/${id}/users`,
    newsletter: (userId: number | string) => `api/users/${userId}/newsletter`,
    unlinkProfileFromAccount: () => `api/users/unlinkProfile`,
    updateLoginType: (iduser: number | string) => `api/users/${iduser}/secondFactor`,
    updateUser: (iduser: number | string) => `api/users/${iduser}`,
    updateUserPassword: (iduser: number | string) => `api/users/${iduser}/password`,
    updateUserSettings: (iduser: number | string) => `api/users/${iduser}/settings`,
    updateUsersContact: (iduser: number | string) => `api/users/${iduser}/contact`,
  },
  VALUETABLES: {
    connectFilesToRoombook: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/values/ifc/${fileId}/connectFilesBetter`,
    createAttachment: (projectId: number | string, tableId: number | string, dataKey: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/attachment-add/${dataKey}`,
    createRecord: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/data`,
    deleteRecord: (projectId: number | string, tableId: number | string, itemId: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/data/${itemId}`,
    getAllInstancesOfObjectTypeJSON: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/data`,
    getAllMainTablesOfProject: (projectId: number | string) => `api/projects/${projectId}/values`,
    getAllReferences: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/references`,
    getAllValueTablesOfProject: (projectId: number | string) => `api/projects/${projectId}/values/tables`,
    getClassificationData: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/values/ifc/${fileId}/ava`,
    getDetailsOfObjectInstanceJSON: (projectId: number | string, tableId: number | string, dataKey: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/data/${dataKey}`,
    getObjectInstancesByReferenceJSON: (
      projectId: number | string,
      tableId: number | string,
      refId: number | string,
      sourceId: number | string
    ) => `api/projects/${projectId}/values/table/${tableId}/ref/${refId}/${sourceId}`,
    getProbisAuthentication: (projectId: number | string) => `api/projects/${projectId}/values/probisAuth`,
    getRoombookFileId: (projectId: number | string, tableId: number | string, dataKey: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/data/${dataKey}/file`,
    getValueTable: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}`,
    getValueTableByName: (projectId: number | string) => `api/projects/${projectId}/values/tableByName`,
    insertIfcModelIntoRoombook: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/values/ifc/${fileId}/create`,
    readAttributes: (projectId: number | string, tableId: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/attributes`,
    removeAttachment: (projectId: number | string, tableId: number | string, dataKey: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/attachment-rem/${dataKey}`,
    searchInValueTablesJSON: (projectId: number | string, valueTableId: number | string) =>
      `api/projects/${projectId}/values/search/${valueTableId}`,
    searchValueTable: (projectId: number | string) => `api/projects/${projectId}/values/searchValueTable`,
    updateProbisAuthentication: (projectId: number | string) => `api/projects/${projectId}/values/probisAuth`,
    updateRecord: (projectId: number | string, tableId: number | string, itemId: number | string) =>
      `api/projects/${projectId}/values/table/${tableId}/data/${itemId}`,
  },
  VIEWER: {
    addComment: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/comments`,
    deleteComment: (projectId: number | string, fileId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/comments/${commentId}`,
    downloadPdfWithoutAnnotations: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/clearPdf`,
    editComment: (projectId: number | string, fileId: number | string, commentId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/comments/${commentId}`,
    getArchivedWebViewerFile: (projectId: number | string, fileId: number | string, archivFileId: number | string) =>
      `api/projects/${projectId}/webviewer/${fileId}/archived/${archivFileId}`,
    getCallGuestWebViewerFile: (callId: number | string, fileId: number | string) =>
      `api/tender/${callId}/webviewer/${fileId}`,
    getComments: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/comments`,
    getEasyViewerFile: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}`,
    getEasyViewerFileSize: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}`,
    getEasyViewerFileSize_1: (projectId: number | string, fileId: number | string, archivFileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/archived/${archivFileId}`,
    getEasyViewerFileSize_3: (callId: number | string, fileId: number | string) =>
      `api/tender/${callId}/easyviewer/${fileId}`,
    getEasyViewerFile_1: (projectId: number | string, fileId: number | string, archivFileId: number | string) =>
      `api/projects/${projectId}/easyviewer/${fileId}/archived/${archivFileId}`,
    getEasyViewerFile_2: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/pdf`,
    getEasyViewerFile_4: (callId: number | string, fileId: number | string) =>
      `api/tender/${callId}/easyviewer/${fileId}`,
    getMetadataFile: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/ifc-metadata`,
    getOnlineViewerConfig: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/onlineviewer/${fileId}/config`,
    getOnlineViewerMarkup: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/onlineviewer/${fileId}/markup`,
    getOnlineViewerUrl: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/onlineviewer/${fileId}`,
    getOnlineViewerUrlForArchivedFile: (
      projectId: number | string,
      fileId: number | string,
      archivFileId: number | string
    ) => `api/projects/${projectId}/onlineviewer/${fileId}/archived/${archivFileId}`,
    getWebDavLink: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/files/${fileId}/webDavLink`,
    getWebViewerAnnotatedFile: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/webviewer/${fileId}/download`,
    getWebViewerFile: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/webviewer/${fileId}`,
    getXktLinkedFile: (projectId: number | string, linkId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/linked/${linkId}/${fileId}/xkt`,
    saveOnlineViewerMarkup: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/onlineviewer/${fileId}/markup`,
  },
  VIEWS: {
    addNewView: (projectId: number | string) => `api/admin/projects/${projectId}/views`,
    addViewRight: (projectId: number | string, viewId: number | string) =>
      `api/admin/projects/${projectId}/views/${viewId}/rights`,
    createViewFilter: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/filters`,
    createViewNavigation: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/navigation`,
    deleteViewFilter: (projectId: number | string, viewId: number | string, filterId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/filters/${filterId}`,
    deleteViewNavigation: (projectId: number | string, viewId: number | string, navigationId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/navigation/${navigationId}`,
    deleteViewRight: (projectId: number | string, viewId: number | string, rightId: number | string) =>
      `api/admin/projects/${projectId}/views/${viewId}/rights/${rightId}`,
    getAllFiles_1: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/all-files`,
    getAllViews: (projectId: number | string) => `api/admin/projects/${projectId}/views`,
    getAllViews_1: (projectId: number | string) => `api/projects/${projectId}/views`,
    getCustomizedExcelList: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/excel/custom`,
    getExcelReport: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/excel`,
    getExportOptions: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/excel/options`,
    getNumberOfExpectedFiles: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/count-files`,
    getView: (projectId: number | string, viewId: number | string) => `api/admin/projects/${projectId}/views/${viewId}`,
    getViewFilters: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/filters`,
    getViewInformationObjectForView: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/information`,
    getViewNavigation: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/navigation`,
    getViewNavigationEntries: (projectId: number | string, viewId: number | string, navigationId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/navigation/${navigationId}`,
    getViewRights: (projectId: number | string, viewId: number | string) =>
      `api/admin/projects/${projectId}/views/${viewId}/rights`,
    saveUserSettingsForView: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/setting`,
    searchFilesByFilterMetadata: (projectId: number | string, viewId: number | string) =>
      `api/projects/${projectId}/views/${viewId}`,
    updateView: (projectId: number | string, viewId: number | string) =>
      `api/admin/projects/${projectId}/views/${viewId}`,
    updateViewFilter: (projectId: number | string, viewId: number | string, filterId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/filters/${filterId}`,
    updateViewNavigation: (projectId: number | string, viewId: number | string, navigationId: number | string) =>
      `api/projects/${projectId}/views/${viewId}/navigation/${navigationId}`,
  },
  WEBVIEWER_ANNOTATIONS: {
    createWebViewerAnnotations: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/webviewer/${fileId}/annotations`,
    createWebViewerCftAnnotations: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/webviewer/annotations`,
    deleteWebViewerAnnotations: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/webviewer/${fileId}/annotations`,
    deleteWebViewerCftAnnotations: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/webviewer/annotations`,
    getWebViewerAnnotations: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/webviewer/${fileId}/annotations`,
    getWebViewerCftAnnotations: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/webviewer/annotations`,
    updateWebViewerAnnotations: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/webviewer/${fileId}/annotations`,
    updateWebViewerCftAnnotations: (projectId: number | string, callId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/tender/calls/${callId}/documents/${fileId}/webviewer/annotations`,
  },
  WERTETABELLE: {
    getWertetabelle: (projectId: number | string) => `api/projects/${projectId}/wertetabelle`,
    search_2: (projectId: number | string) => `api/projects/${projectId}/wertetabelle/search`,
  },
  WOPI: {
    generateAccessToken: (projectId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/wopi/${fileId}`,
  },
  WORKFLOWS: {
    attachWorkflowDocs: (projectId: number | string, workflowId: number | string) =>
      `api/projects/${projectId}/workflows/${workflowId}/documents`,
    cancelWorkflow: (projectId: number | string, workflowId: number | string) =>
      `api/projects/${projectId}/workflows/${workflowId}`,
    changeWorkflow: (projectId: number | string, workflowId: number | string) =>
      `api/projects/${projectId}/workflows/${workflowId}`,
    changeWorkflowStep: (projectId: number | string, actionId: number | string) =>
      `api/projects/${projectId}/workflows/actions/${actionId}`,
    changeWorkflowVariables: (projectId: number | string, workflowId: number | string) =>
      `api/projects/${projectId}/workflows/${workflowId}/variables`,
    checkoutParcel: (projectId: number | string, parcelId: number | string) =>
      `api/projects/${projectId}/workflows/reviewtab/${parcelId}/checkout`,
    createAdHocTask: (projectId: number | string, actionId: number | string) =>
      `api/projects/${projectId}/workflows/actions/${actionId}/adhoc`,
    deleteAdHocTask: (projectId: number | string, actionId: number | string, adHocActionId: number | string) =>
      `api/projects/${projectId}/workflows/actions/${actionId}/adhoc/${adHocActionId}`,
    getAllWorkflows: (projectId: number | string) => `api/projects/${projectId}/workflows/admin`,
    getMyWorkflows: (projectId: number | string) => `api/projects/${projectId}/workflows`,
    getWorkflowDefinitions: (projectId: number | string) => `api/projects/${projectId}/workflows/definitions`,
    getWorkflowDefinitionsByFileIds: (projectId: number | string) => `api/projects/${projectId}/workflows/definitions`,
    getWorkflowDefinitionsForSearch: (projectId: number | string) =>
      `api/projects/${projectId}/workflows/definitionsForSearch`,
    getWorkflowDetails: (projectId: number | string, workflowId: number | string) =>
      `api/projects/${projectId}/workflows/${workflowId}`,
    getWorkflowFlowchart: (projectId: number | string, wfId: number | string) =>
      `api/projects/${projectId}/workflows/visualFC/${wfId}`,
    getWorkflowListExcel: (projectId: number | string) => `api/projects/${projectId}/workflows/search.excel`,
    getWorkflowReactDiagram: (projectId: number | string, wfId: number | string) =>
      `api/projects/${projectId}/workflows/visualRD/${wfId}`,
    getWorkflowReviewTab: (projectId: number | string) => `api/projects/${projectId}/workflows/reviewtab`,
    getWorkflowTaskById: (projectId: number | string, actionId: number | string) =>
      `api/projects/${projectId}/workflows/actions/${actionId}`,
    getWorkflowTasks: (projectId: number | string) => `api/projects/${projectId}/workflows/actionlist`,
    getWorkflowVariables: (projectId: number | string, workflowId: number | string) =>
      `api/projects/${projectId}/workflows/${workflowId}/variables`,
    releaseParcelById: (projectId: number | string, parcelId: number | string) =>
      `api/projects/${projectId}/workflows/reviewtab/${parcelId}/checkout`,
    removeFileFromWorkflow: (projectId: number | string, actionId: number | string, fileId: number | string) =>
      `api/projects/${projectId}/workflows/actions/${actionId}/file/${fileId}`,
    removeFileFromWorkflowForAdmins: (
      projectId: number | string,
      workflowId: number | string,
      fileId: number | string
    ) => `api/projects/${projectId}/workflows/${workflowId}/file/${fileId}`,
    search_3: (projectId: number | string) => `api/projects/${projectId}/workflows/search`,
    startWorkflow: (projectId: number | string) => `api/projects/${projectId}/workflows`,
    updateWorkflowReviewTab: (projectId: number | string) => `api/projects/${projectId}/workflows/reviewtab`,
  },
};
